webpackJsonp([0],{

/***/ "+GxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module",class:[_vm.width, _vm.tall, _vm.isDragging ? 'dragging' : ''],style:(_vm.position),on:{"mousedown":function($event){$event.stopPropagation();_vm.startDragging($event)}}},[_c(_vm.module.type,{tag:"component",attrs:{"id":_vm.module.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/p7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Drive',
      drive: 0.1,

      inlets: [{ label: 'input' }],
      outlets: [{ label: 'output' }]
    };
  },
  created: function created() {
    this.inlets[0].audio = this.input = this.context.createGain();
    this.outlets[0].audio = this.output = this.context.createGain();

    this.$watch('drive', this.setDrive);
  },
  destroyed: function destroyed() {},


  methods: {
    setDrive: function setDrive(d) {
      // this.osc.frequency.value = f;
    }
  }
});

/***/ }),

/***/ "1n5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3LnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var params = {
  delay: {
    default: 100,
    min: 20,
    max: 1000
  },
  feedback: {
    default: 0.45,
    min: 0,
    max: 0.9
  },
  cutoff: {
    default: 20000,
    min: 20,
    max: 20000
  },
  wet: {
    default: 0.5,
    min: 0,
    max: 1
  },
  dry: {
    default: 1,
    min: 0,
    max: 1
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Delay',
      delay: params.delay.default,
      wet: params.wet.default,
      dry: params.dry.default,
      feedback: params.feedback.default,
      cutoff: params.cutoff.default,

      inlets: [{ label: 'in' }, { label: 'mod' }],
      outlets: [{ label: 'out-1' }, { label: 'out-2' }]
    };
  },
  created: function created() {
    this.inlets[0].audio = this.input = this.context.createGain();
    this.inlets[1].audio = this.context.createGain(); // input is -1 : 1
    this.outlets[0].audio = this.output = this.context.createGain();

    // this._delayNode = this.input = this.output = this.context.createDelay(this.toSeconds(options.maxDelay));


    this.activateNode = this.context.createGain();
    this.dryNode = this.context.createGain();
    this.wetNode = this.context.createGain();
    this.filter = this.context.createBiquadFilter();
    this.delayNode = this.context.createDelay(10);
    this.feedbackNode = this.context.createGain();

    this.activateNode.connect(this.delayNode);
    this.activateNode.connect(this.dryNode);
    this.delayNode.connect(this.filter);
    this.filter.connect(this.feedbackNode);
    this.feedbackNode.connect(this.delayNode);
    this.feedbackNode.connect(this.wetNode);
    this.wetNode.connect(this.output);
    this.dryNode.connect(this.output);

    this.filter.type = 'lowpass';

    // this.$watch('delay', this.setFreq);
    this.$watch('wet', this.setWet);
    this.$watch('dry', this.setDry);
    this.$watch('feedback', this.setFeedback);
    this.$watch('cutoff', this.setCutoff);
  },
  destroyed: function destroyed() {
    // this.inlets[0].disconnect();
    // this.outlets[0].disconnect();
    this.activateNode.disconnect();
    this.delayNode.disconnect();
    this.filter.disconnect();
    this.feedbackNode.disconnect();
    this.wetNode.disconnect();
    this.dryNode.disconnect();
  },


  methods: {
    setDelay: function setDelay(d) {
      // this.osc.frequency.value = f;
    },
    setWet: function setWet(w) {},
    setDry: function setDry(d) {},
    setFeedback: function setFeedback(f) {},
    setCutoff: function setCutoff(c) {}
  }
});

/***/ }),

/***/ "3hfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('line',{staticClass:"dotted",attrs:{"x1":_vm.x,"y1":_vm.y,"x2":_vm.cursorX,"y2":_vm.cursorY,"stroke":"white","stroke-dasharray":"5, 5","stroke-width":"3"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4mEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT; });
/* harmony export (immutable) */ __webpack_exports__["b"] = validateData;
/*

class DataApi {
  constructor(rawData) {
    this.rawData = rawData;
  }
  mapIntoObject(arr) {
    return arr.reduce((acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    }, {});
  }
  getArticles() {
    return this.mapIntoObject(this.rawData.articles);
  }
  getAuthors() {
    return this.mapIntoObject(this.rawData.authors);
  }
}

export default DataApi;
*/

var DEFAULT = {
  id: 0,
  name: '<blank>',
  modules: [{ 'type': 'MasterOut', 'id': 0, 'x': 0, 'y': 0 }],
  connections: [],
  parameterSets: [{
    name: '<empty>',
    parameters: {}
  }]
};

/**
 * This validates the Patch Object coming from Firebase, and
 * ensures that each Object has all the requesite fields. This
 * is important because everywhere else in the App we assume that
 * these fields are present; all data checks happen only here.
 * @param  {Object} patches The Object of the user's patches.
 * @return {Object) The patches Object, with any data-corrections made.
 */
function validateData(patches) {
  var _loop = function _loop(key) {
    var patch = patches[key];

    if (!patch.name) {
      console.warn('Patch "%s" missing name', key);
      patch.name = DEFAULT.name;
    }

    if (patch.id === undefined) {
      console.warn('Patch "%s" missing id. Fixing...', patch.name);
      patch.id = DEFAULT.id;
    }

    if (!patch.parameterSets) {
      console.warn('Patch "%s" missing parameterSets. Fixing...', patch.name);
      patch.parameterSets = DEFAULT.parameterSets;
    }

    patch.parameterSets.forEach(function (set) {
      set.name = set.name || '<missing>';
      if (!set.parameters) {
        console.warn('Patch "%s" missing parameters in "%s". Fixing...', patch.name, set.name);
        set.parameters = DEFAULT.parameterSets[0].parameters;
      }
    });

    if (!patch.connections) {
      console.warn('Patch "%s" missing connections. Fixing...', patch.name);
      patch.connections = DEFAULT.connections;
    }

    if (!patch.modules) {
      console.warn('Patch %s no modules.... (not fixed)', patch.name);
    }
  };

  for (var key in patches) {
    _loop(key);
  }

  return patches;
}

/***/ }),

/***/ "5T4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Connection_vue__ = __webpack_require__("KCDZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1a71a42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Connection_vue__ = __webpack_require__("5oTC");
function injectStyle (ssrContext) {
  __webpack_require__("jA6h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Connection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1a71a42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Connection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5oTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line',{attrs:{"x1":_vm.x1,"y1":_vm.y1,"x2":_vm.x2,"y2":_vm.y2,"stroke":_vm.stroke,"stroke-width":"3"},on:{"click":function($event){_vm.removeConnection(_vm.id)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "79Ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCA_vue__ = __webpack_require__("CyOR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bcf7130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCA_vue__ = __webpack_require__("GdQk");
function injectStyle (ssrContext) {
  __webpack_require__("HZzU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bcf7130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCA_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8nzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__("n/Yi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Module from './system/Module2';
// import { signal } from '../audio';


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'NoteIn',
      active: 0,
      note: 0,
      freq: 0,
      velocity: 0,
      mod: 0,
      bend: 0,
      outlets: [{ label: 'freq' },
      // { label: 'gate' },
      { label: 'vel' }, { label: 'bend' }, { label: 'mod' }]
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_NOTEON, this.noteOn);
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_NOTEOFF, this.noteOff);
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_CONTROLLER, this.controller);
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_PITCH, this.pitchWheel);
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_POLY, this.polyPressure);

    this.outlets[0].data = 'freq'; // "string" of the property to connect
    this.outlets[1].data = 'velocity'; // for now. should be "gate" or "trigger"...
    // this.outlets[2].data = 'gate';
    this.outlets[2].data = 'bend';
    this.outlets[3].data = 'mod';

    // navigator.serviceWorker.register('service-worker.js', {
    //   scope: './'
    // }).then(function(reg) {
    //   console.log('ServiceWorker registered', reg);
    // });

    // // ONE WAY COMMUNICATION
    // if (navigator.serviceWorker.controller) {
    //   console.log('Sending message to service worker');
    //   navigator.serviceWorker.controller.postMessage({
    //     'command': 'oneWayCommunication',
    //     'message': 'Hi, SW'
    //   });
    // }


    this.keydown = function (e) {
      switch (e.code) {
        case 'KeyA':
          _this.noteOn(63, 127);
          break;
        case 'KeyS':
          _this.noteOn(65, 127);
          break;
        case 'KeyD':
          _this.noteOn(66, 127);
          break;
        case 'KeyF':
          _this.noteOn(68, 127);
          break;
        case 'KeyG':
          _this.noteOn(70, 127);
          break;

        default:
          break;
      }
    };

    this.keyup = function (e) {
      switch (e.code) {
        case 'KeyA':
          _this.noteOff(63);
          break;
        case 'KeyS':
          _this.noteOff(65);
          break;
        case 'KeyD':
          _this.noteOff(66);
          break;
        case 'KeyF':
          _this.noteOff(68);
          break;
        case 'KeyG':
          _this.noteOff(70);
          break;

        default:
          break;
      }
    };

    window.addEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].KEY_DOWN, this.keydown);
    window.addEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].KEY_UP, this.keyup);
  },
  destroyed: function destroyed() {
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_NOTEON, this.noteOn);
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_NOTEOFF, this.noteOff);
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_CONTROLLER, this.controller);
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_PITCH, this.pitchWheel);
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_POLY, this.polyPressure);

    window.removeEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].KEY_DOWN, this.keydown);
    window.removeEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].KEY_UP, this.keyup);
  },


  methods: {
    /**
     * [noteOn description]
     * @param  {[type]} note     Midi note.
     * @param  {[type]} velocity Midi velocity beteen 1 - 127.
     */
    noteOn: function noteOn(note, velocity) {
      this.note = note;
      this.velocity = (velocity / 127.0).toFixed(3);
      this.freq = 440 * Math.pow(2, (note - 69) / 12);
      this.active = note;
    },
    noteOff: function noteOff(note) {
      this.note = note;

      if (note === this.active) {
        this.active = 0;
        this.velocity = 0;
      }
    },
    pitchWheel: function pitchWheel(bend) {
      this.bend = +bend.toFixed(3);
    },
    controller: function controller(target, val) {
      this.mod = (val / 127.0).toFixed(3);
    },
    polyPressure: function polyPressure(note, pressure) {}
  }
});

/***/ }),

/***/ "8r02":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9lU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AZer":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Slider__ = __webpack_require__("l9G1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Dropdown__ = __webpack_require__("uXcz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio__ = __webpack_require__("AdJ8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */], Slider: __WEBPACK_IMPORTED_MODULE_1__UI_Slider__["a" /* default */], Dropdown: __WEBPACK_IMPORTED_MODULE_2__UI_Dropdown__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'VCO',
      freq: 440,
      mod: 0,
      PW: 0,
      phase: 0,
      detune: 0,
      type: 'sine',
      types: ['sine', 'sawtooth', 'triangle', 'square'], // ==> 'pulse' instead

      inlets: [{ label: 'freq',
        desc: 'The frequency of the Oscillator. [A-rate / k-rate]'
      }, { label: 'mod',
        desc: 'Modulation input, ie. LFO or similar. Depth is controlled via the slider'
      }, { label: 'pulse',
        desc: 'Pulse width modulation. [0 - 1]'
      }],

      outlets: [{ label: 'output',
        desc: 'Audio output' }]
    };
  },
  created: function created() {
    // Oscillator
    this.osc_ = this.context.createOscillator();
    this.osc_.frequency.value = this.freq;
    this.osc_.type = this.type;

    // Modulation depth
    // this.modDepth_ = new Parameter(0);
    this.modDepth_ = this.context.createGain();
    this.modDepth_.value = 0;
    this.modDepth_.connect(this.osc_.detune); // input connects to audioParam (freq) "mod"

    // Pulse width
    this.pulse_ = new __WEBPACK_IMPORTED_MODULE_3__audio__["d" /* Parameter */](0);

    // Inlets
    this.inlets[0].data = this.setFreq; // NOTE: if the input is a k-rate control, we connect it here...
    this.inlets[1].audio = this.modDepth_; // NOTE: this is how we control the modulation (ie. in the _receiving_ module rather than the source)
    this.inlets[2].audio = this.pulse_.input;

    // Outlets
    this.outlets[0].audio = this.osc_;

    // Map k-Params
    this.$watch('freq', this.setFreq);
    this.$watch('type', this.setType);
    this.$watch('PW', this.setPulse);
    this.$watch('mod', this.setDepth);

    this.osc_.start();
  },


  methods: {
    /**
     * k-rate control of the Oscillator frequency.
     * TODO: this should set a `base` modification frequency, around which an
     * A-rate parameter may apply modulations.
     * @param  {Float} f frequency
     */
    setFreq: function setFreq(f) {
      if (f < 1) {
        return;
      } // no DC
      // this.osc_.cancelScheduledValues();

      this.osc_.frequency.exponentialRampToValueAtTime(f, this.context.currentTime + 0.01); // 10ms
      this.freq = f; // updates knob display
    },


    /**
     * Update wave type
     * @param  {String} t One of the pre-defined oscillator wave types
     */
    setType: function setType(t) {
      this.osc_.type = t;
    },


    /**
     * Update Modulation depth. Range is from 0 to 500 cents.
     * @param  {Float} g  Depth, between 0 and 100.
     */
    setDepth: function setDepth(d) {
      var currentFreq = this.osc_.frequency.value;
      var cents = d * 5; // 0 -> 500 cents
      var freq = currentFreq * Math.pow(2, cents / 1200);
      // const depth = currentFreq * d / 100.0;

      console.log(freq);

      this.modDepth_.gain.value = d; // freq - currentFreq;
    },


    /**
     * Update Oscillator Pulse width
     * @param  {Float} p  Pulse, between 0 and 1.
     */
    setPulse: function setPulse(p) {
      this.pulse_.input = this.PW = p;
    },


    /**
     * The phase of the oscillator in degrees.
     * @type {Degrees}
     * @name phase
     * @example
     * osc.phase = 180; //flips the phase of the oscillator
     */
    getPhase: function getPhase() {
      return this._phase * (180 / Math.PI);
    },
    setPhase: function setPhase(phase) {
      this._phase = phase * Math.PI / 180;
      // reset the type
      this.type = this._type;
    }
  }
});

/***/ }),

/***/ "AdJ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* harmony export (immutable) */ __webpack_exports__["f"] = signal;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Parameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Meter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Oscillator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PWM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * The application's audio context.
 * @type {AudioContext}
 */
var context = window.AudioContext && new window.AudioContext();

/**
 * Generata a constant stream of 1's at the audio-rate.
 * @type {Object}
 */
var constants = {}; // memoize this shizz??
function signal() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (constants[value]) {
    return constants[value];
  } else {
    // Generate (mono) buffer with 2 samples
    var _signal = context.createBufferSource();
    var buffer = context.createBuffer(1, 2, context.sampleRate);

    // set each sample to 1
    buffer.getChannelData(0)[0] = value; // 2 items, as Safari chokes on 1
    buffer.getChannelData(0)[1] = value;

    _signal.channelCountMode = 'explicit';
    _signal.channelCount = 1;
    _signal.buffer = buffer;
    _signal.loop = true;
    _signal.start(0);

    constants[value] = _signal;

    return _signal;
    // return context.createConstantSource(value);  // one day
  }
};

/**
 * @class Provides a uniform interface to an automatable value. Accepts both
 *        A-rate and k-rate inputs (ie. connection agnostic), while allowing
 *        sample-accurate manipulation of any parameter.
 * @param {Number} value Initial value of the parameter.
 */
var Parameter = function () {
  function Parameter() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Parameter);

    var param = context.createGain();

    param.gain.value = value;
    this.set = function (value) {
      param.gain.value = value;
    };
    this.output = param;
    this.input = param;

    // this.input = (audio) ? param.gain : param.gain.value

    signal(1).connect(param);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Parameter, [{
    key: 'destroy',
    value: function destroy() {
      this.output.disconnect();
      this.input = this.output = null;
    }
  }]);

  return Parameter;
}();
// export class Parameter2 {
//   constructor(value = 0) {
//     const param = context.createGain();

//     param.gain.value = value;
//     this.set = (value) => { param.gain.value = value; };
//     this.param = param;
//     signal(1).connect(param);

//     return param;
//   }

//   destroy() {
//     this.param.disconnect();
//     this.param = null;
//   }
// }


/**
 * @class Audio VU meter. Uses deprecated ScriptNode, tho'
 * @param {AudioContext} audioContext The webaudio context.
 * @param {Float} clipLevel    The rms peak at which it is considered to clip.
 * @param {Float} averaging    [description]
 * @param {Integer} clipLag    The release time, in ms, after clipping.
 */
var Meter = function () {
  function Meter(canvas) {
    var clipLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.98;
    var averaging = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.95;
    var clipLag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 750;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Meter);

    // if (!context) { return; }

    var processor = this.processor = context.createScriptProcessor(512);

    processor.onaudioprocess = this.processAudio;
    processor.clipping = false;
    processor.lastClip = 0;
    processor.volume = 0;
    processor.clipLevel = clipLevel; //  || 0.98;
    processor.averaging = averaging; //  || 0.95;
    processor.clipLag = clipLag; //  || 750;

    // this will have no effect, since we don't copy the input to the output,
    // but works around a current Chrome bug.
    processor.connect(context.destination);
    // ---------------------------------------------

    return processor;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Meter, [{
    key: 'processAudio',
    value: function processAudio(event) {
      var buf = event.inputBuffer.getChannelData(0);
      var bufLength = buf.length;
      var sum = 0;
      var x;

      // Do a root-mean-square on the samples: sum up the squares...
      for (var i = 0; i < bufLength; i++) {
        x = buf[i];
        if (Math.abs(x) >= this.clipLevel) {
          this.clipping = true;
          this.lastClip = window.performance.now();
        }
        sum += x * x;
      }

      // ... then take the square root of the sum.
      var rms = Math.sqrt(sum / bufLength);

      // Now smooth this out with the averaging factor applied
      // to the previous sample - take the max here because we
      // want "fast attack, slow release."
      this.volume = Math.max(rms, this.volume * this.averaging);
    }
  }]);

  return Meter;
}();

/**
 * @class Creates a wrapper around the Oscillator AudioNode, with the ability
 *        to start and stop playing.
 * @param {Number} f Initial frequency of the oscillator.
 * @param {String} t Initial type of the oscillator.
 */
var Oscillator = function () {
  function Oscillator(f, t) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Oscillator);

    this.osc = context.createOscillator();
    this.osc.type = this.type = t;
    this.frequency = new Parameter(f);
    this.frequency.output.connect(this.osc.frequency);
    this.output = this.osc;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Oscillator, [{
    key: 'start',
    value: function start() {
      this.osc.start();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.osc.stop();
      this.frequency = null; // .destroy(); ?
    }
  }]);

  return Oscillator;
}();

/**
 * Create a sawtooth oscillator. By adding a DC offset, we can move it up or
 * down. We then threshold the result to either 1 or -1 using a waveshaper,
 * which turns it square ie. a PWM waveform.
 * Reference: https://github.com/pendragon-andyh/WebAudio-PulseOscillator
 */
var PWM = function () {
  function PWM() {
    var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 440;
    var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PWM);

    this.frequency = new Parameter(f);
    this.width = new Parameter(w);

    this._curve = this.generateCurve();

    // create sawtooth
    this._saw = context.createOscillator();
    this._saw.type = 'sawtooth';

    // create the waveshaper
    this._pulseShaper = context.createWaveShaper();
    this._pulseShaper.curve = this._curve;

    // connectify
    this._saw.connect(this._pulseShaper);

    // output
    this.output = this._pulseShaper;
  }

  /**
   * Start the Oscillator
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PWM, [{
    key: 'start',
    value: function start() {
      this.frequency.output.connect(this._saw.frequency); // control the frequency
      this.width.output.connect(this._pulseShaper); // control pulse width
      this._saw.start();
    }

    /**
     * Un-start the Oscillator
     */

  }, {
    key: 'stop',
    value: function stop() {
      this._saw.disconnect();
      this._pulseShaper.disconnect();

      this.frequency.destroy();
      this.width.destroy();

      this._saw = null;
      this._curve = null;
      this._pulseShaper = null;
    }

    /**
     * Generate a curve to be used in Waveshaping the Sawtooth wave.
     * NOTE: why 256 samples?? No idea. A goodly number I guess
     */

  }, {
    key: 'generateCurve',
    value: function generateCurve() {
      var pulseCurve = new Float32Array(256);

      for (var i = 0; i < 128; i++) {
        pulseCurve[i] = -1;
        pulseCurve[i + 128] = 1;
      }

      return pulseCurve;
    }
  }]);

  return PWM;
}();

/*
//
//
//
function setupNodeMessaging(node) {
  // This handles communication back from the volume meter
  node.onmessage = function(event) {
    if (event.data instanceof Object) {
      if (event.data.hasOwnProperty('clip')) {
        this.clip = event.data.clip;
      }
      if (event.data.hasOwnProperty('volume')) {
        this.volume = event.data.volume;
      }
    }
  };

  // Set up some default configuration parameters
  node.postMessage({
    'smoothing': 0.9,   // Smoothing parameter
    'clipLevel': 0.9,   // Level to consider 'clipping'
    'clipLag': 750,     // How long to keep 'clipping' lit up after clip (ms)
    'updating': 100      // How frequently to update volume and clip param (ms)
  });

  // Set up volume and clip attributes.  These will be updated by our onmessage.
  node.volume = 0;
  node.clip = false;
}

var meter = null; // well.... that won't work as it's statically bound at runtime...
// , vuFactory;
context.createAudioWorker('workers/meter.js').then(function(factory) {
  // cache 'factory' in case you want to create more nodes!
  // vuFactory = factory;
  meter = factory.createNode([1], []); // we don't need an output, and let's force to mono
  setupNodeMessaging(meter);
});

// window.requestAnimationFrame( function(timestamp) {
//   if (vuNode) {
//   // Draw a bar based on vuNode.volume and vuNode.clip
//   }
// });
*/

/***/ }),

/***/ "AnxV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ap8I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CAKp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CR/D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cpl7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Env_vue__ = __webpack_require__("sccb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bfb204_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Env_vue__ = __webpack_require__("CtyO");
function injectStyle (ssrContext) {
  __webpack_require__("SOSg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Env_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bfb204_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Env_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CtyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"env 3U"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('knob',{attrs:{"param":"attack","min":0.01,"max":1,"default":0.1,"decimals":2},on:{"value":function($event){_vm.A = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"decay","min":0.01,"max":1,"default":0.2,"decimals":2},on:{"value":function($event){_vm.D = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"sustain","min":0.01,"max":1,"default":0.8,"decimals":2},on:{"value":function($event){_vm.S = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"release","min":0.01,"max":1,"default":0.3,"decimals":2},on:{"value":function($event){_vm.R = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Env")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CyOR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'VCA',
      inlets: [{
        label: 'signal'
        // audio: null,
        // data: null
      }, {
        label: 'gain'
        // audio: null
      }],

      outlets: [{
        label: 'output'
        // audio: null
      }]
    };
  },
  created: function created() {
    var vca = this.context.createGain();
    // IMPORTANT. Set ORIGINAL gain value i.e. "offset"... which is what is ADDED into future signals. I Think...???
    // If this is not set, than any signal in will... be additive to itself, or ...something
    vca.gain.value = 0;

    this.inlets[0].audio = vca;
    this.inlets[1].audio = vca.gain;

    this.outlets[0].audio = vca;
  },
  destroyed: function destroyed() {
    // this.inlets[0].audio.disconnect(); // this is done in Connection
  }
});

/***/ }),

/***/ "D8Wr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reverb_vue__ = __webpack_require__("R1Ci");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29709741_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reverb_vue__ = __webpack_require__("JO5z");
function injectStyle (ssrContext) {
  __webpack_require__("xc2I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reverb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29709741_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reverb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DD6E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dm5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue__ = __webpack_require__("HB2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fc3e8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contextMenu_vue__ = __webpack_require__("zm4a");
function injectStyle (ssrContext) {
  __webpack_require__("8r02")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fc3e8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contextMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GXat":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSC_vue__ = __webpack_require__("ZNu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dedefb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSC_vue__ = __webpack_require__("I3z3");
function injectStyle (ssrContext) {
  __webpack_require__("CAKp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dedefb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GdQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vca"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_vm._v("\n    VCA\n  ")]),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("VCA")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HB2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      active: '',
      coords: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    visible: function visible() {
      return !!this.coords.length;
    },
    position: function position() {
      return {
        left: this.coords[0] + 'px' || 0,
        top: this.coords[1] + 'px' || 0
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['editing'])),

  created: function created() {
    var _this = this;

    window.addEventListener('click', function (e) {
      _this.coords = [];
    });

    window.addEventListener('keydown', function (e) {
      switch (e.code) {
        case 'Escape':
          _this.coords = [];
          break;
        default:
        // console.log(e.code);
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var header = document.querySelector('header');
    var grid = document.querySelector('#modules');

    document.body.addEventListener('contextmenu', function (e) {
      e.preventDefault();

      if (header === e.target || header.contains(e.target)) {
        _this2.active = 'file';
      } else if (grid === e.target || grid.contains(e.target)) {
        _this2.active = 'add';
      } else {
        _this2.coords = [];
        _this2.active = '';
        return false;
      }

      if (_this2.editing) {
        _this2.coords = [e.pageX, e.pageY];
      }
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    newModule: function newModule(type) {
      var offset = document.querySelector('header').offsetHeight;

      this.addModule({
        type: type,
        coords: [this.coords[0], this.coords[1] - offset]
      });

      this.$bus.$emit('module:add');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addModule']))
});

/***/ }),

/***/ "HB2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_system_Auth__ = __webpack_require__("W102");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events__ = __webpack_require__("n/Yi");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Auth: __WEBPACK_IMPORTED_MODULE_2__components_system_Auth__["a" /* default */]
  },

  data: function data() {
    return {
      patchIndex: 1,
      paramsIndex: 1
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    currentPatchKey: {
      get: function get() {
        return this.$store.state.patchKey;
      },
      set: function set(key) {
        this.$store.commit('SET_KEY', key);
      }
    },

    currentParamsKey: {
      get: function get() {
        return this.$store.state.parameterKey;
      },
      set: function set(key) {
        this.$store.commit('SET_PARAMETERS_KEY', key);
      }
    },

    currentPatchName: {
      get: function get() {
        return this.$store.state.name;
      },
      set: function set(value) {
        this.$store.commit('SET_NAME', value);
      }
    },

    currentParamsName: {
      get: function get() {
        var key = this.$store.state.parameterKey;
        return this.$store.state.parameterSets[key] && this.$store.state.parameterSets[key].name;
      },
      set: function set(value) {
        this.$store.commit('SET_PARAMETERS_NAME', value);
      }
    }

  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['patches', 'parameterSets', 'editing'])),

  mounted: function mounted() {
    this.load();

    // update patchIndex display and selected option in dropdown
    // NOTE: <select> doesn't seem to be ready at mount
    // const options = this.$refs.patch.options;
    // console.log(options.length, Object.keys(this.patches).length);
    // update the 00 display
    // update the <select> selectedIndex
    // Array.prototype.forEach.call(options, (opt, i) => {
    //   if (opt.value === this.currentPatchKey) {
    //     this.patchIndex = i;
    //     this.$refs.patch.selectedIndex = i;
    //   }
    // });
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    save: function save() {
      this.savePatch();
    },
    load: function load() {
      this.loadPatch();
      this.$nextTick(function () {
        console.log('%c Setting parameters ', 'background:#666;color:white;font-weight:bold;');
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_4__events__["a" /* EVENT */].PARAMETERS_LOAD);
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_4__events__["a" /* EVENT */].APP_SORT);
      });
    },


    // -----------------

    add: function add() {
      if (this.patches.length >= 9) {
        return;
      }
      this.addPatch(); // CREATE a new blank patch...
      this.loadPatch(); // ...AND then select it

      this.patchIndex = this.$refs.patch.selectedIndex = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.patches).length; // as our new patch is at the end of the list
    },
    remove: function remove() {
      var confirm = window.confirm('Delete ' + this.currentPatchName + '?');

      if (this.patches.length <= 1 || !confirm) {
        return;
      }

      this.removePatch(this.currentPatchKey);
      this.patchIndex = this.$refs.patch.selectedIndex = 1;
      this.currentPatchKey = 0;
    },
    select: function select(e) {
      this.currentPatchKey = e.target.value;
      this.patchIndex = e.target.selectedIndex;
      this.currentParamsKey = 0; // always select 1st set when new patch loaded
      this.load();
    },


    // -----------------

    addParams: function addParams() {
      this.$store.commit('ADD_PARAMETERS');
      this.currentParamsKey = this.parameterSets.length - 1;

      this.paramsIndex = this.$refs.params.selectedIndex = this.parameterSets.length;
    },
    removeParams: function removeParams(id) {
      var confirm = window.confirm('Delete ' + this.currentParamsName + '?');

      if (this.$store.state.parameterSets.length <= 1 || !confirm) {
        return;
      }

      this.$store.commit('REMOVE_PARAMETERS', this.currentParamsKey);
      this.paramsIndex = this.$refs.params.selectedIndex = 1;
      this.currentParamsKey = 0;
    },
    selectParams: function selectParams(e) {
      this.currentParamsKey = e.target.value;
      this.paramsIndex = e.target.selectedIndex;
      this.$store.commit('SET_PARAMETERS_KEY', this.currentParamsKey);
      this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_4__events__["a" /* EVENT */].PARAMETERS_LOAD);
      console.log('%c Fetching parameters ', 'background:#666;color:white;font-weight:bold;');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['savePatch', 'loadPatch', 'addPatch', 'removePatch']))
});

/***/ }),

/***/ "HKa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return provider; });
/* harmony export (immutable) */ __webpack_exports__["c"] = generateKey;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_firebase__ = __webpack_require__("YWcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__("OPUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__("0jrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__("X2NH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_database__);



 // import auth into firebase namespace
 // import database into firebase namespace

__WEBPACK_IMPORTED_MODULE_2_firebase_app__["initializeApp"](__WEBPACK_IMPORTED_MODULE_1__config_firebase___default.a);

var database = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]();

var auth = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["auth"]();
var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase_app__["auth"].GoogleAuthProvider();

/**
 * Generate a key based on the patch's name.
 * @return {[type]} [description]
 */
// export function generateKey(str) {
//   return str.toLowerCase().trim().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
// }

/**
 * Generate a UUID to be used as a key.
 * @return {[type]} [description]
 */
// export function generateKey() {
//   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//     const r = Math.random() * 16 | 0;
//     const v = c === 'x' ? r : (r & 0x3 | 0x8);
//
//     return v.toString(16);
//   });
// }

/**
 * Generate a "Firebase friendly" unique identifier that may be sorted lexigraphically.
 * @return {[type]} [description]
 */
function generateKey() {
  var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
  var now = new Date().getTime();
  var timeStampChars = new Array(8);
  var result = void 0;

  // 8 characters of timestamp data at the beginning
  for (var i = 7; i >= 0; i--) {
    timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
    now = Math.floor(now / 64);
  }

  // convert to string
  result = timeStampChars.join('');

  // 4 more characters of randomness
  for (var _i = 0; _i < 4; _i++) {
    var random = Math.floor(Math.random() * 64);
    result += PUSH_CHARS.charAt(random);
  }

  return result;
}

/**
 * Simple Firebase API (CRUD) wrapper.
 * @type {Object}
 */
var api = {
  /**
   * Fetch data from Firebase. This happens only once (ie. no "listeners")
   * @return {Promise} The loaded data.
   */
  load: function load(path) {
    if (auth.currentUser) {
      var getSnapshot = database.ref(path).once('value');

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        getSnapshot.then(function (response) {
          resolve(response.val());
        }).catch(reject);
      });
    }
  },


  /**
   * Create a new Object in the database.
   * NOTE: destructive operation, will overwrite if anything happens to be at this path.
   * @return {Promise} A Firebase Promise, actually.
   */
  create: function create(key, data) {
    // return database.ref('patch/' + key).set(data);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      database.ref('patch/' + key).set(data).then(resolve).catch(reject);
    });
  },


  /**
   * Save / update an exiting Object in the database.
   * @return {Promise} A Firebase Promise, actually.
   */
  save: function save(path, data) {
    return database.ref(path).update(data);
  },


  /**
   * Add a new item to Firebase
   * @param {String} path [description]
   * @param {Object} data The data to add
   * @return {Promise} With the new key reference.
   */
  add: function add(path, data) {
    var items = database.ref(path); // ie. patch, or patch/juno/parameterSets

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      items.push(data).then(function (response) {
        resolve(response.key);
      }).catch(reject);
    });
  },


  /**
   * Remove this here thing.
   * @param {String} path The data at this path will be deleted.
   * @return {Promise}
   */
  remove: function remove(path) {
    if (path === '/' || !path) {
      return;
    }

    var item = database.ref(path);

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      item.remove().then(resolve).catch(reject);
    });
  }
};

/***/ }),

/***/ "HZzU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I3z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oscillator"},[_c('div',{staticClass:"module-details"},[_c('h3',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_vm._l((_vm.types),function(type){return _c('input',{attrs:{"type":"checkbox"},domProps:{"value":type},on:{"mousedown":function($event){$event.stopPropagation();}}})}),_vm._v(_vm._s(_vm.type)),_vm._v(" "),_c('slider',{attrs:{"param":"mod","min":0,"max":100},on:{"value":function($event){_vm.mod = $event}}}),_vm._v(" "),_c('p',[_vm._v("OSC")]),_vm._v(" "),_c('knob',{attrs:{"param":"freq","min":1,"max":2000},on:{"value":function($event){_vm.freq = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"PW","min":0,"max":6.28},on:{"value":function($event){_vm.PW = $event}}})],2),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _PARAMETER_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _CONNECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _PARAMETERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins__ = __webpack_require__("bGDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var _KEY = 'patchKey';
var _PARAMETER_KEY = 'parameterKey';
var _NAME = 'name';
var _MODULES = 'modules';
var _CONNECTIONS = 'connections';
var _PARAMETERS = 'parameterSets';

// -----------------------------------------------
//  STATE
// -----------------------------------------------

var state = {

  // APP: USER STATE
  power: false,
  editing: false,
  focused: undefined, // "Hovered": for Module Info, Connections.  TODO move to $bus?
  active: 0, // "Clicked": for Dragging, Deleting.

  // PATCH: WORKING DATA                             // NOTE: data is populated in actions.js
  id: 0,
  name: '',
  modules: [],
  connections: [],
  parameterSets: [],
  parameterKey: 0,

  // APP: "PERSISTENT" STORAGE
  patchKey: localStorage.getItem(_KEY) || '', // key of active patch

  // UI: STUFFS
  canvasOffset: 0,

  // TODO: remove; use firebase + SW instead;
  patches: {} // all available patches, cached here
};

// -----------------------------------------------
//  STORE
// -----------------------------------------------

/* harmony default export */ __webpack_exports__["g"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  plugins: __WEBPACK_IMPORTED_MODULE_2__plugins__["a" /* default */]
  // strict: process.env.NODE_ENV !== 'production'
}));

/***/ }),

/***/ "JB2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteIn_vue__ = __webpack_require__("8nzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff5358d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteIn_vue__ = __webpack_require__("NKTd");
function injectStyle (ssrContext) {
  __webpack_require__("pKEi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff5358d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JO5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reverb"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('knob',{attrs:{"param":"seconds","min":0,"max":5},on:{"value":function($event){_vm.seconds = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"decay","min":0,"max":5},on:{"value":function($event){_vm.decay = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Reverb")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JmZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node"},[_c('div',{staticClass:"module-details"},[_c('h3',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_vm._t("interface"),_vm._v("\n    "+_vm._s(_vm.position)),_c('br'),_c('br'),_vm._v("\n    x "+_vm._s(_vm.x)),_c('br'),_vm._v("\n    y "+_vm._s(_vm.y)),_c('br'),_vm._v("\n    col "+_vm._s(_vm.col)),_c('br'),_vm._v("\n    row "+_vm._s(_vm.row)),_c('br'),_vm._v("\n    "+_vm._s(_vm.position.left)),_c('br'),_vm._v("\n    "+_vm._s(_vm.dragging)),_c('br'),_vm._v("\n    edit: "+_vm._s(_vm.$store.state.editing)+"\n  ")],2),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KCDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dimensions__ = __webpack_require__("fxBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audio__ = __webpack_require__("AdJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: Number,
    to: Object, // { port, id }
    from: Object // { port, id }

    // inlet: Object,  // { port, id }
    // outlet: Object  // { port, id }
  },

  computed: {
    x1: function x1() {
      return this.source.coords.x + __WEBPACK_IMPORTED_MODULE_1__dimensions__["a" /* cellWidth */] + 3;
    },
    y1: function y1() {
      return this.source.coords.y + this.from.port * 20 + 27;
    },
    x2: function x2() {
      return this.dest.coords.x - 3;
    },
    y2: function y2() {
      return this.dest.coords.y + this.to.port * 20 + 27;
    }
  },

  data: function data() {
    return {
      stroke: 'white'

      // For reference (this doesn't need to be reactive):
      // source: {
      //   outlet: null,
      //   module: null,
      //   id: null
      // }
    };
  },
  created: function created() {
    this.getToAndFromModules();
    this.route();
  },
  destroyed: function destroyed() {
    this.route(false);
    this.unwatch && this.unwatch();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    /**
     * Connect the actual AudioNode of the module. This is the meat-and-bones of
     * the App, so to speak.
     * @type {Boolean} connect Connect two nodes if true, disconnect if false.
     * @return {Void}
     */
    route: function route() {
      var connect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // const outlet = this.source.outlet;
      // const inlet = this.dest.inlet;
      var outlet = this.source.module.outlets[this.from.port];
      var inlet = this.dest.module.inlets[this.to.port];

      try {
        if (outlet.audio && inlet.audio) {
          // -------------------
          // AUDIO -> AUDIO
          // -------------------
          var source = outlet.audio;
          var destination = inlet.audio;

          connect ? source.connect(destination) : source.disconnect(destination);

          //
        } else if (outlet.data && inlet.audio) {
          // -------------------
          // DATA -> AUDIO
          // -------------------

          console.log('CONNECTION FROM DAT TO AUDIO ', this.from.id, this.to.id);
          var interpolator = new __WEBPACK_IMPORTED_MODULE_2__audio__["d" /* Parameter */](0);

          this.source.module.$watch(outlet.data, interpolator.set);
          interpolator.output.connect(inlet.audio);

          //
        } else if (outlet.data && inlet.data) {
          // -------------------
          // DATA -> DATA
          // -------------------
          var action = outlet.data; // STRING
          var update = inlet.data; // FUNCTION

          if (typeof update === 'function') {
            // "this.unwatch" is a fn that removes itself
            // "action" is a string -- is refers us to the property on source.module that should be watched;
            // ... when it is changed, the receiver function, "update" (on toModule), is fired with the new value.
            this.unwatch = this.source.module.$watch(action, update);
            this.stroke = '#999';
            // this.fromModule.$on(action, update);

            //
          }
        } else {
          var inType = inlet.data ? 'data' : inlet.audio ? 'audio' : 'unknown';
          var outType = outlet.data ? 'data' : outlet.audio ? 'audio' : 'unknown';

          this.stroke = 'red';

          throw '[error] connection: mismatch (' + outType + ' ⟹ ' + inType + ')'; // eslint-disable-line
        }

        // success message:
        console.log('%c[connection] %s ⟹ %s', 'color: green', this.source.module.name, this.dest.module.name);
        //
      } catch (e) {
        this.logError(e);
      }
    },


    /**
     * Fetch a Vue Component from the App, given a particular id.
     * NOTE: we fetch the Component from the App (not the Store), as that is what
     *       contains the actual AudioNode.
     * @type {Number} id The id of the module to fetch.
     */
    getToAndFromModules: function getToAndFromModules() {
      var _this = this;

      try {
        var modules = this.$parent.$children;
        var from = modules.find(function (m) {
          return m.id === _this.from.id;
        });
        var to = modules.find(function (m) {
          return m.id === _this.to.id;
        });

        this.dest = {
          coords: to,
          module: this.to.id === 0 ? to : to.$children[0],
          id: this.to.id
        };

        this.source = {
          coords: from,
          module: from.$children[0],
          id: this.from.id
        };
      } catch (e) {
        this.logError(e);
      }
    },
    logError: function logError(e) {
      console.log('%c%s', 'color: red', e.toString().slice(0, 100));
      console.log('%c[error] connection: #%s.%d ⟹ #%s.%d', 'color: red', this.from.id, this.from.port + 1, this.to.id, this.to.port + 1);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['removeConnection']))
});

/***/ }),

/***/ "LENT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delay_vue__ = __webpack_require__("3LnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f9c084_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delay_vue__ = __webpack_require__("LMND");
function injectStyle (ssrContext) {
  __webpack_require__("jSOQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f9c084_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LMND":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delay"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('Knob',{attrs:{"param":"delay","min":20,"max":1000},on:{"value":function($event){_vm.delay = $event}}}),_vm._v(" "),_c('Knob',{attrs:{"param":"wet","min":0,"max":1,"decimals":2},on:{"value":function($event){_vm.wet = $event}}}),_vm._v(" "),_c('Knob',{attrs:{"param":"dry","min":0,"max":1,"decimals":2},on:{"value":function($event){_vm.dry = $event}}}),_vm._v(" "),_c('Knob',{attrs:{"param":"feedback","min":0,"max":0.9,"decimals":2},on:{"value":function($event){_vm.feedback = $event}}}),_vm._v(" "),_c('Knob',{attrs:{"param":"cut","min":20,"max":20000},on:{"value":function($event){_vm.cut = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Delay")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lym0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parameter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__ = __webpack_require__("yI0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__("n/Yi");

/**
 * Parameter.
 * This mixin provide base functionality for any Parameter.
 * @type {Object}
 */



var parameter = {
  props: {
    param: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'linear'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    }
  },

  data: function data() {
    return {
      active: false,
      startValue: 0,
      startY: null,
      internalValue: 0, // 0 -> 1 internally
      range: 1,
      value: 0
    };
  },
  created: function created() {
    var self = this;

    this.id = this.$parent.id + '-' + this.param;
    this.range = this.max - this.min;
    this.$emit('value', this.value); // update parent w/ value
    // this.$emit('update:value', this.value); // update parent w/ value

    // this.$store.commit('REGISTER_PARAMETER', this.id);

    // TODO: avoid dupl w/ every knob? ie. one mouseup listener in the App, or: just add / remove dynamically as needed?
    this.mouseup = function (e) {
      window.mouseDown = false;
      self.active = false;

      document.body.style.webkitUserSelect = 'auto';
      document.body.style.userSelect = 'auto';
    };

    this.mousemove = function (e) {
      if (window.mouseDown && self.active) {
        self.update(e);
      }
    };

    window.addEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_UP, this.mouseup);
    window.addEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_MOVE, this.mousemove);

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].PARAMETERS_LOAD, this.fetchValue);

    console.log('%c[parameter] Creating %s Knob', 'color: orange', this.param);
  },
  destroyed: function destroyed() {
    this.$store.commit('REMOVE_PARAMETER', this.id);
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].PARAMETERS_LOAD, this.fetchValue);
    window.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_UP, this.mouseup);
    window.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_MOVE, this.mousemove);

    console.log('%c[parameter] Destroying %s %s', 'color: grey', this.type, this.id);
  },


  methods: {
    /**
     * Set up calculations for updating new knob values.
     * @param {Event} e The mouse down Event.
     */
    start: function start(e) {
      window.mouseDown = true;
      this.active = true;
      this.startValue = this.internalValue;
      this.startY = e.clientY;
    },


    /**
     * Updates new knob values on mouse move.
     * @param {Event} e The mouse move Event.
     */
    update: function update(e) {
      var delta = (this.startY - e.clientY) / 100.0; // drag distance, 1/100th pixels
      var internalValue = Math.min(1, Math.max(0, this.startValue + delta));

      if (this.internalValue === internalValue) return;

      this.internalValue = internalValue;
      this.value = this.computeValue(internalValue);

      this.$emit('value', this.value); // update parent w/ value
      this.$store.commit('SET_PARAMETER', {
        id: this.id,
        value: this.value
      });
    },


    /**
     * Maps the interval knob value to the desired range. Linear or exponential.
     * @param {number}  n The value to map.
     * @param {boolean} extract If true, extracts the internalValue from value,
     *                          otherwise calculate value from internalValue.
     */
    computeValue: function computeValue(n) {
      var extract = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (extract) {
        return parseFloat(this.mode === 'log' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default()((n + this.range - this.min) / this.range) : (n - this.min) / this.range);
      } else {
        return parseFloat(this.mode === 'log' ? this.range * Math.pow(2, n) - this.range + this.min : n * this.range + this.min);
      }
    },
    fetchValue: function fetchValue() {
      /*
      NOTE: this is only necessary when the parameterSet does *not* contain values for
      all parameters. In essence, this function will update itself when the parameterSet
      is changed, to either the value in the $store (if it exists) or the default value.
      */
      this.value = this.$store.getters.parameters[this.id] || this.default || 0;
      this.internalValue = this.computeValue(this.value, true);
      this.$emit('value', this.value);

      console.log('%c[parameter] %s %s set to %f', 'color: orange', this.param, this.type, this.value);
    }
  }
};

/***/ }),

/***/ "M8g3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Synth__ = __webpack_require__("hZXk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatchManager_vue__ = __webpack_require__("wApk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UI_contextMenu__ = __webpack_require__("Dm5c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_functional_inlets__ = __webpack_require__("tFqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_functional_outlets__ = __webpack_require__("dQSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_firebase__ = __webpack_require__("HKa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__audio__ = __webpack_require__("AdJ8");












__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();
var authenticated = false;

// Global Event Bus
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype, '$bus', {
  get: function get() {
    return this.$root.bus;
  }
});

// Global isAuthenticated variable
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype, '$authenticated', {
  get: function get() {
    return this.$root.authenticated;
  }
});

// AudioContext Mixin: all Components will have access to AudioContext
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
  data: function data() {
    return { context: __WEBPACK_IMPORTED_MODULE_10__audio__["e" /* context */] };
  }
});

// Global Components (inlets / outlets)
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('inlets', __WEBPACK_IMPORTED_MODULE_6__components_functional_inlets__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('outlets', __WEBPACK_IMPORTED_MODULE_7__components_functional_outlets__["a" /* default */]);

// Register a global custom directive called v-context-menu
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('context-menu', {
  inserted: function inserted(element) {}
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_2__store__["g" /* default */],
  el: 'main',
  components: { Synth: __WEBPACK_IMPORTED_MODULE_3__Synth__["a" /* default */], PatchManager: __WEBPACK_IMPORTED_MODULE_4__PatchManager_vue__["a" /* default */], ContextMenu: __WEBPACK_IMPORTED_MODULE_5__components_UI_contextMenu__["a" /* default */] },
  data: { bus: bus, authenticated: authenticated },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['fetchPatches'])),
  beforeCreate: function beforeCreate() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_9__store_firebase__["b" /* auth */].onAuthStateChanged(function (user) {
      _this.authenticated = !!user;

      if (_this.authenticated) {
        _this.fetchPatches();
      }
    });
  }
});

/***/ }),

/***/ "NKTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note-in"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('span',{staticClass:"received",class:{active: _vm.active}}),_vm._v(" "),_c('p',[_vm._v("note: "+_vm._s(_vm.note))]),_vm._v(" "),_c('p',[_vm._v("vel:  ...")]),_vm._v(" "),_c('p',[_vm._v("freq: "+_vm._s(Math.round(_vm.freq))+" Hz")]),_vm._v(" "),_c('p',[_vm._v("amp:  "+_vm._s(_vm.velocity))]),_vm._v(" "),_c('p',[_vm._v("bend: "+_vm._s(_vm.bend))]),_vm._v(" "),_c('p',[_vm._v("mod:  "+_vm._s(_vm.mod))])]),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("NoteIn")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OfeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compressor"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_vm._v("\n    ....\n  ")]),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Compressor")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Os9B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QZ/0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debugger"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_vm._v("\n    "+_vm._s(_vm.peak)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Debugger")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R1Ci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Reverb',
      seconds: 3,
      decay: 2,

      inlets: [{
        label: 'input-1'
      }, {
        label: 'input-2'
      }],

      outlets: [{
        label: 'output-1'
      }, {
        label: 'output-2'
      }]
    };
  },
  created: function created() {
    var reverb = this.convolver = this.context.createConvolver();

    // inputs
    this.inlets[0].audio = reverb;
    this.outlets[0].audio = reverb;

    this.$watch('seconds', this.setReverb);
    this.$watch('decay', this.setDecay);
  },


  // destroyed() {
  //   this.convolver.disconnect();
  // },

  methods: {
    /**
     * k-rate control of the Reverb
     * @param  {Float} s reverb in seconds
     */
    setReverb: function setReverb(s) {
      // this.convolver.reverb.value = s;
    },


    /**
     * k-rate control of the Reverb decay
     * @param  {Float} d decay in seconds
     */
    setDecay: function setDecay(d) {
      // this.convolver.decay.value = d;
    }
  }
});

/***/ }),

/***/ "R9gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Module_vue__ = __webpack_require__("kEqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c11f41a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Module_vue__ = __webpack_require__("+GxS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Module_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c11f41a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Module_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RVtK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_firebase__ = __webpack_require__("HKa/");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    signIn: function signIn() {
      __WEBPACK_IMPORTED_MODULE_0__store_firebase__["b" /* auth */].signInWithPopup(__WEBPACK_IMPORTED_MODULE_0__store_firebase__["d" /* provider */]).catch(function (err) {
        if (err.code === 'auth/web-storage-unsupported') {
          window.alert(err.message);
        }
      });
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_0__store_firebase__["b" /* auth */].signOut();
    }
  }
});

/***/ }),

/***/ "SHjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Compressor',

      inlets: [{ label: 'input' }],
      outlets: [{ label: 'output' }]
    };
  },
  created: function created() {
    this.inlets[0].audio = this.input = this.context.createGain();
    this.outlets[0].audio = this.output = this.context.createGain();
  },
  destroyed: function destroyed() {},


  methods: {}
});

/***/ }),

/***/ "SOSg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYz6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCO_vue__ = __webpack_require__("AZer");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa79622_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCO_vue__ = __webpack_require__("x10d");
function injectStyle (ssrContext) {
  __webpack_require__("CR/D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCO_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa79622_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCO_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SiEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__("n/Yi");
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { parameter } from '../../mixins/parameter';


/* harmony default export */ __webpack_exports__["a"] = ({
  // mixins: [parameter],

  props: {
    param: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      active: false,
      selected: 1,
      type: 'Dropdown'
    };
  },
  created: function created() {
    this.id = this.$parent.id + '-' + this.param;
    this.$emit('value', this.options[0]); // update parent w/ value
    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].PARAMETERS_LOAD, this.fetchValue);

    console.log('%c[parameter] Creating %s Dropdown', 'color: orange', this.param);
  },
  destroyed: function destroyed() {
    this.$store.commit('REMOVE_PARAMETER', this.id);
    this.$bus.$off(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].PARAMETERS_LOAD, this.fetchValue);

    console.log('%c[parameter] Destroying %s %s', 'color: grey', this.type, this.id);
  },


  methods: {
    open: function open() {
      var _this = this;

      this.active = true;

      this.dismiss = function () {
        _this.active = false;
        window.removeEventListener('mouseup', _this.dismiss);
      };

      window.addEventListener('mouseup', this.dismiss);
    },
    select: function select(index) {
      var value = this.options[index];

      this.selected = index;
      this.$emit('value', value); // update parent w/ value
      this.$store.commit('SET_PARAMETER', {
        id: this.id,
        value: value
      });
    },


    // TODO duplication w/ mixins/Parameter.js
    fetchValue: function fetchValue() {
      var value = this.$store.getters.parameters[this.id] || this.options[0];

      this.$emit('value', value);
      this.selected = this.options.indexOf(value);

      console.log('%c[parameter] %s %s set to %s', 'color: orange', this.param, this.type, value);
    }
  }

});

/***/ }),

/***/ "Swtb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return draggable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dimensions__ = __webpack_require__("fxBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__("n/Yi");
/**
 * Draggable.
 * This mixin enables dragging of a Component. A position Object is updated in the Component's
 * data, and any/all connections to any inputs/outputs are also updated and redrawn.
 * @type {Object}
 */




var dragObj = {
  zIndex: 0,
  cursorStartX: null,
  cursorStartY: null,
  startX: null,
  startY: null
};

var draggable = {
  computed: {
    position: function position() {
      return {
        left: this.$store.state.editing || this.isDragging ? this.x + 'px' : this.module.col * __WEBPACK_IMPORTED_MODULE_0__dimensions__["d" /* rackWidth */] + 'px',
        top: this.$store.state.editing || this.isDragging ? this.y + 'px' : this.module.row * __WEBPACK_IMPORTED_MODULE_0__dimensions__["c" /* rackHeight */] + 'px'
      };
    }
  },

  data: function data() {
    return {
      x: 0,
      y: 0,
      isDragging: false
    };
  },
  created: function created() {
    this.x = this.module.x;
    this.y = this.module.y;
  },


  methods: {
    startDragging: function startDragging(event) {
      var node = this.$el;
      var x = node.offsetLeft; // Calculate explicity because could be in play mode, in which ...
      var y = node.offsetTop; // case x,y would not pertain to the actual node coords.

      node.style.zIndex = ++dragObj.zIndex; // Update element's z-index.

      // Save starting positions of cursor and element.
      dragObj.cursorStartX = event.clientX;
      dragObj.cursorStartY = event.clientY;
      dragObj.startX = x;
      dragObj.startY = y;

      this.isDragging = true;
      this.x = x; // necessary as the module's internal coords may be different if in play mode
      this.y = y;

      this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].DRAG_START, [x, y], this.$el);

      // Capture mousemove and mouseup events on the page.
      document.addEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_MOVE, this.whileDragging);
      document.addEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_UP, this.stopDragging);
    },
    whileDragging: function whileDragging(event) {
      var x = dragObj.startX + event.clientX - dragObj.cursorStartX;
      var y = dragObj.startY + event.clientY - dragObj.cursorStartY;

      // we _always_ want to change the module's coordinates
      // while dragging, whether in editing mode or not:
      this.x = x;
      this.y = y;

      this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].DRAG_ACTIVE, [x, y], this.$el);
    },
    stopDragging: function stopDragging(event) {
      this.isDragging = false;
      this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].DRAG_END, this.id);

      if (this.$store.state.editing) {
        // TODO && cursorStartY != this.y etc
        // we only want to update the Store with the
        // new coordinates if we are in editing mode:
        this.$store.commit('UPDATE_GRID_POSITION', {
          id: this.module.id,
          x: this.x,
          y: this.y
        });
      } else {
        // otherwise, restore the x,y coordinates -- we don't want the
        // module to have moved around when we switch out of play mode
        var module = this.$store.getters.active;

        this.x = module.x;
        this.y = module.y;
      }

      document.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_MOVE, this.whileDragging);
      document.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_UP, this.stopDragging);
    }
  }
};

/***/ }),

/***/ "Ta8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LFO_vue__ = __webpack_require__("hF4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9f36214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LFO_vue__ = __webpack_require__("zwCk");
function injectStyle (ssrContext) {
  __webpack_require__("hNeE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LFO_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9f36214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LFO_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UAjr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UPMN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ugl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mixer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('knob',{attrs:{"param":"one","min":0,"max":100},on:{"value":function($event){_vm.one = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"two","min":0,"max":100},on:{"value":function($event){_vm.two = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"three","min":0,"max":100},on:{"value":function($event){_vm.three = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"four","min":0,"max":100},on:{"value":function($event){_vm.four = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Mixer")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patches", function() { return patches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parameterSets", function() { return parameterSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "power", function() { return power; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editing", function() { return editing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focused", function() { return focused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return active; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modules", function() { return modules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connections", function() { return connections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parameterKey", function() { return parameterKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parameters", function() { return parameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bounds", function() { return bounds; });
// -----------------------------------------------
//  GETTERS
// -----------------------------------------------

var patches = function patches(state) {
                                      return state.patches;
};
var parameterSets = function parameterSets(state) {
                                      return state.parameterSets;
};

var power = function power(state) {
                                      return state.power;
};
var editing = function editing(state) {
                                      return state.editing;
};
var focused = function focused(state) {
                                      return state.focused;
};
var active = function active(state) {
                                      return state.modules.find(function (module) {
                                                                            return module.id === state.active;
                                      });
};

var modules = function modules(state) {
                                      return state.modules.filter(function (module) {
                                                                            return module.id !== 0;
                                      });
};
var connections = function connections(state) {
                                      return state.connections;
};
var parameterKey = function parameterKey(state) {
                                      return state.parameterKey;
};
var parameters = function parameters(state) {
                                      return state.parameterSets[state.parameterKey] && state.parameterSets[state.parameterKey].parameters || {};
};

var bounds = function bounds(state) {
                                      return state.modules.slice(1).reduce(function (max, module) {
                                                                            return Math.max(max, module.x);
                                      }, 0);
};

/***/ }),

/***/ "W102":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__("RVtK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa9c190_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__("Wn4H");
function injectStyle (ssrContext) {
  __webpack_require__("bYZM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa9c190_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W8xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_sortable__ = __webpack_require__("ySG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events__ = __webpack_require__("n/Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_system_Connecting__ = __webpack_require__("ZmJw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_system_Connection__ = __webpack_require__("5T4l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_system_MasterOut__ = __webpack_require__("asDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_system_Midi_vue__ = __webpack_require__("lz4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_system_Module__ = __webpack_require__("R9gu");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_sortable__["a" /* sortable */]],

  components: {
    masterOut: __WEBPACK_IMPORTED_MODULE_6__components_system_MasterOut__["a" /* default */],
    connecting: __WEBPACK_IMPORTED_MODULE_4__components_system_Connecting__["a" /* default */],
    connection: __WEBPACK_IMPORTED_MODULE_5__components_system_Connection__["a" /* default */],
    midi: __WEBPACK_IMPORTED_MODULE_7__components_system_Midi_vue__["a" /* default */],
    module: __WEBPACK_IMPORTED_MODULE_8__components_system_Module__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    width: function width() {
      var canvasWidth = this.bounds + 124 + 40; // .. + module width + 40
      return this.editing ? 'width: ' + canvasWidth + 'px' : 'width: auto';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['power', 'editing', 'active', 'modules', 'bounds', 'connections'])),

  data: function data() {
    return {
      sorting: false
    };
  },
  created: function created() {
    var _this = this;

    console.log('%c ◌ Synth: loading... ', 'background:black;color:white;font-weight:bold');

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].DRAG_START, function (coords, el) {
      if (!_this.editing) {
        _this.startSorting(); // from sortable mixin
      }
    });

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].DRAG_ACTIVE, function (coords, el) {
      if (!_this.editing) {
        _this.whileSorting(el); // from sortable mixin
      }
    });

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].DRAG_END, function () {
      if (!_this.editing) {
        _this.stopSorting(); // from sortable mixin
      }
    });

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].APP_SORT, function () {
      _this.initSorting(_this.$refs.grid);
    });

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].MODULE_ADD, function () {
      _this.$nextTick(function () {
        var item = this.modules.slice(-1)[0]; // get last (newest) item

        this.gridList.items = this.modules;
        this.gridList.moveItemToPosition(item, [0, 0]);
      });
    });

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].MODULE_REMOVE, function () {
      _this.$nextTick(function () {
        _this.gridList.items = _this.modules;
        _this.gridList._pullItemsToLeft();
      });
    });

    window.addEventListener(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].KEY_DOWN, function (e) {
      switch (e.code) {
        case 'Delete':
        case 'Backspace':
          _this.removeModule();
          _this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].MODULE_REMOVE);
          break;
        case 'Tab':
          _this.toggleEditMode();
          e.preventDefault(); // do not tab through <select>, fields, etc
          break;
        case 'Escape':
          // this.togglePower();
          break;
        case 'Space':
          // this.togglePlay();  // one day, if i plug in a timeline
          break;
        case 'ShiftLeft':
        case 'ShiftRight':
          // WE only want to rearrange the module-rack if shift is held;
          // otherwise, we probably want to play the module
          // this.toggleSorting;
          _this.sorting = true;
          break;
        default:
        // console.log(e.code);
      }
    });

    window.addEventListener(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].KEY_UP, function (e) {
      switch (e.code) {
        case 'ShiftLeft':
        case 'ShiftRight':
          _this.sorting = false;
          break;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var grid = this.$refs.grid; // rare time we need to scrape DOM.
    grid.addEventListener(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* EVENT */].SCROLL, function (e) {
      if (_this2.editing) {
        _this2.$store.commit('UPDATE_SCROLL_OFFSET', e.target.scrollLeft);
      }
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['togglePower', 'toggleEditMode', 'removeModule', 'setActive', 'clearActive', 'setFocus', 'clearFocus']))
});

/***/ }),

/***/ "WfeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comb_vue__ = __webpack_require__("xHYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c31a1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comb_vue__ = __webpack_require__("XLcv");
function injectStyle (ssrContext) {
  __webpack_require__("UPMN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c31a1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wn4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[(_vm.$root.authenticated)?_c('button',{staticClass:"ring active",attrs:{"title":"sign out"},on:{"click":_vm.signOut}}):_c('button',{staticClass:"ring",attrs:{"title":"sign in"},on:{"click":_vm.signIn}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XKhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__("raWs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8f11dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__("mLHM");
function injectStyle (ssrContext) {
  __webpack_require__("gkgt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8f11dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XLcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comb"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('knob',{attrs:{"param":"resonance","min":0,"max":100},on:{"value":function($event){_vm.resonance = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"cutoff","min":40,"max":16000,"scale":"log"},on:{"value":function($event){_vm.cutoff = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Comb")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XkEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mixer_vue__ = __webpack_require__("cU1s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ce917c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mixer_vue__ = __webpack_require__("Ugl2");
function injectStyle (ssrContext) {
  __webpack_require__("9lU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mixer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ce917c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mixer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xpkp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_parameter__ = __webpack_require__("Lym0");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_parameter__["a" /* parameter */]],

  data: function data() {
    return {
      step: 1,
      type: 'Slider'
    };
  },


  computed: {
    bottom: function bottom() {
      return 'bottom:' + this.internalValue * 100 + '%';
    }
  }
});

/***/ }),

/***/ "YWcn":
/***/ (function(module, exports) {

var config = {
  apiKey: "AIzaSyBcxE9ynMPhVDdTWVywMAPgx8Tq242FWvE",
  authDomain: "malformed-synth.firebaseapp.com",
  databaseURL: "https://malformed-synth.firebaseio.com",
  storageBucket: "malformed-synth.appspot.com",
  messagingSenderId: "893642604788"
};

module.exports = config;


/***/ }),

/***/ "YjpD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z0Ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Debugger',
      peak: 0,
      inlets: [{
        label: 'input'
        // audio: null
      }]
    };
  },
  created: function created() {
    /*
    Usage:
    audioNode = createAudioMeter(this.context,clipLevel,averaging,clipLag);
    this.context: the AudioContext you're using.
    clipLevel: the level (0 to 1) that you would consider "clipping".
       Defaults to 0.98.
    averaging: how "smoothed" you would like the meter to be over time.
       Should be between 0 and less than 1.  Defaults to 0.95.
    clipLag: how long you would like the "clipping" indicator to show
       after clipping has occured, in milliseconds.  Defaults to 750ms.
    Access the clipping through node.checkClipping(); use node.shutdown to get rid of it.
    */

    var processor = this.processor = this.context.createScriptProcessor(512);
    processor.onaudioprocess = volumeAudioProcess;
    processor.clipping = false;
    processor.lastClip = 0;
    processor.volume = 0;
    processor.clipLevel = 0.98;
    processor.averaging = 0.95;
    processor.clipLag = 750;

    // this will have no effect, since we don't copy the input to the output,
    // but works around a current Chrome bug.
    processor.connect(this.context.destination);

    processor.checkClipping = function () {
      if (!this.clipping) {
        return false;
      }

      if (this.lastClip + this.clipLag < window.performance.now()) {
        this.clipping = false;
        return this.clipping;
      };

      processor.shutdown = function () {
        this.disconnect();
        this.onaudioprocess = null;
      };

      return processor;
    };

    function volumeAudioProcess(event) {
      var buf = event.inputBuffer.getChannelData(0);
      var bufLength = buf.length;
      var sum = 0;
      var x;

      // Do a root-mean-square on the samples: sum up the squares...
      for (var i = 0; i < bufLength; i++) {
        x = buf[i];
        if (Math.abs(x) >= this.clipLevel) {
          this.clipping = true;
          this.lastClip = window.performance.now();
        }
        sum += x * x;
      }

      // ... then take the square root of the sum.
      var rms = Math.sqrt(sum / bufLength);

      // Now smooth this out with the averaging factor applied
      // to the previous sample - take the max here because we
      // want "fast attack, slow release."
      this.volume = Math.max(rms, this.volume * this.averaging);
    }

    this.inlets[0].audio = processor;
    this.loop();

    console.log('%c[component] Creating Debugger', 'color: blue');
  },
  destroyed: function destroyed() {
    this.processor.disconnect();
  },


  methods: {
    loop: function loop() {
      this.peak = this.processor.volume.toFixed(3);
      // this.clipping = this.processor.clipping;

      if (this.peak > 1.0) {
        console.log('Debugger %s: clipped', this.id);
      }
      // set up the next visual callback
      window.requestAnimationFrame(this.loop);
      // window.setTimeout(this.loop, 250);
    }
  }
});

/***/ }),

/***/ "ZNu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__audio__ = __webpack_require__("AdJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Knob__ = __webpack_require__("nd8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Slider__ = __webpack_require__("l9G1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_1__UI_Knob__["a" /* default */], Slider: __WEBPACK_IMPORTED_MODULE_2__UI_Slider__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Oscillator B',

      freq: 440,
      mod: 0,
      PW: 0,
      type: 'sine',
      types: ['sine', 'sawtooth', 'triangle', 'pulse'],

      inlets: [{ label: 'freq' }, { label: 'FM' }, { label: 'PWM' }],

      outlets: [{ label: 'output' }]
    };
  },
  created: function created() {
    this.osc = new __WEBPACK_IMPORTED_MODULE_0__audio__["b" /* Oscillator */](this.freq, this.type);
    this.pwm = new __WEBPACK_IMPORTED_MODULE_0__audio__["c" /* PWM */]();

    // this.gain = this.context.createGain();
    // this.gain.value = 0;
    // this.gain.connect(this.osc.frequency);      // input connects to audioParam (freq) "mod"

    this.osc.start();

    this.inlets[0].data = this.setFreq;
    this.outlets[0].audio = this.osc;

    // k-Param for controlling mod, sync
    this.$watch('freq', this.setFreq);
    this.$watch('mod', this.setMod);
    this.$watch('type', this.setType);
  },
  destroyed: function destroyed() {
    this.osc.destroy();
  },


  methods: {
    /**
     * k-rate control of the Oscillator frequency
     * @param  {Float} f frequency
     */
    setFreq: function setFreq(f) {
      // this.node.frequency.value = f;
      this.osc.frequency.value = f;
      // this.osc.frequency.setValueAtTime(f, context.currentTime);
    },


    /**
     * Update wave type
     * @param  {String} t One of the pre-defined oscillator wave types
     */
    setType: function setType(t) {
      this.osc.type = t;
    },


    /**
     * Update Oscillator gain
     * @param  {Float} g  Gain, between 0 and 1.
     */
    setMod: function setMod(g) {
      this.gain.value = g;
    },


    /**
     * The phase of the oscillator in degrees.
     * @type {Degrees}
     * @name phase
     * @example
     * osc.phase = 180; //flips the phase of the oscillator
     */
    getPhase: function getPhase() {
      return this._phase * (180 / Math.PI);
    },
    setPhase: function setPhase(phase) {
      this._phase = phase * Math.PI / 180;
      // reset the type
      this.type = this._type;
    }
  }
});

/***/ }),

/***/ "ZbSR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZmJw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Connecting_vue__ = __webpack_require__("oMfw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46fdb2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Connecting_vue__ = __webpack_require__("3hfJ");
function injectStyle (ssrContext) {
  __webpack_require__("Os9B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Connecting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46fdb2f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Connecting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZzyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Node_vue__ = __webpack_require__("pn+P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04849364_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Node_vue__ = __webpack_require__("JmZS");
function injectStyle (ssrContext) {
  __webpack_require__("M8g3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Node_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04849364_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Node_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "asDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterOut_vue__ = __webpack_require__("w2aM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b2a2cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterOut_vue__ = __webpack_require__("cDBc");
function injectStyle (ssrContext) {
  __webpack_require__("UAjr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b2a2cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bGDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("IcnI");



var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, _ref) {
    var patchKey = _ref.patchKey;

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* _KEY */], patchKey);
  });
  store.subscribe(function (mutation, _ref2) {
    var name = _ref2.name;

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__index__["d" /* _NAME */], name);
  });
  store.subscribe(function (mutation, _ref3) {
    var modules = _ref3.modules;

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__index__["c" /* _MODULES */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(modules));
  });
  store.subscribe(function (mutation, _ref4) {
    var connections = _ref4.connections;

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* _CONNECTIONS */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(connections));
  });
  store.subscribe(function (mutation, _ref5) {
    var parameterSets = _ref5.parameterSets;

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__index__["e" /* _PARAMETERS */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parameterSets));
  });
  store.subscribe(function (mutation, _ref6) {
    var parameterKey = _ref6.parameterKey;

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__index__["f" /* _PARAMETER_KEY */], parameterKey);
  });
  store.subscribe(function (mutation, _ref7) {
    var id = _ref7.id;

    localStorage.setItem('id', id);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ([localStoragePlugin]);

/***/ }),

/***/ "bYZM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9bl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drive"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('Knob',{attrs:{"param":"drive","min":20,"max":1000},on:{"value":function($event){_vm.drive = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Drive")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module",attrs:{"id":"master-out"},on:{"mouseover":function($event){_vm.setFocus(_vm.id)},"mouseout":_vm.clearFocus}},[_c('div',{staticClass:"module-interface"},[_c('VU',{attrs:{"audio":_vm.out1}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gain),expression:"gain"}],attrs:{"type":"range","orient":"vertical","min":"0","max":"1","step":"0.05"},domProps:{"value":(_vm.gain)},on:{"__r":function($event){_vm.gain=$event.target.value}}}),_vm._v(" "),_c('VU',{attrs:{"audio":_vm.out2}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cU1s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Mixer',
      'one': 0,
      'two': 0,
      'three': 0,
      'four': 0,

      inlets: [{ label: 'in-1' }, { label: 'in-2' }, { label: 'in-3' }, { label: 'in 4' }],
      outlets: [{ label: 'out-1' }]
    };
  },
  mounted: function mounted() {
    // inputs
    this.inlets[0].audio = this.context.createGain();
    this.inlets[1].audio = this.context.createGain();
    this.inlets[2].audio = this.context.createGain();
    this.inlets[3].audio = this.context.createGain();

    // outputs
    this.outlets[0].audio = this.context.createGain();

    // connectify
    this.inlets[0].audio.connect(this.outlets[0].audio);
    this.inlets[1].audio.connect(this.outlets[0].audio);
    this.inlets[2].audio.connect(this.outlets[0].audio);
    this.inlets[3].audio.connect(this.outlets[0].audio);
  },


  methods: {
    // update() {
    //   numConnected = 1; // how many active connections
    //   this.outlets[0].audio.gain.value = 1 / numConnected;
    // }
  }
});

/***/ }),

/***/ "cmom":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dQSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: { ports: Array },
  // template: `
  // <div v-once class="outlets">
  //   <span v-for="(outlet, index) in ports"
  //     @mousedown.stop="newConnection(outlet)"
  //     :data-label="outlet.label"
  //     :data-port="index"
  //     class="outlet">
  //   </span>
  // </div>
  // `
  render: function render(createElement, context) {
    var ports = context.props.ports;

    return createElement('div', {
      class: { 'outlets': true }
    }, ports.map(function (port, i) {
      return createElement('span', {
        on: {
          mousedown: function mousedown(e) {
            e.stopPropagation();
            context.parent.$root.$bus.$emit('connection:start', i, context.parent.id);
          }
        },
        class: { 'outlet': true },
        attrs: {
          'data-label': port.label,
          'data-port': i
        }
      });
    }));
  }
});

/***/ }),

/***/ "dR88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"vu",staticClass:"vu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dRge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider",on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();_vm.start($event)}}},[_c('div',{staticClass:"fill",style:(_vm.bottom)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ePeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_parameter__ = __webpack_require__("Lym0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var SIZE = 20;
var X = 24; // half the css knob radius
var Y = 24;

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees + 90) * Math.PI / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

function describeArc(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);
  var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

  return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_parameter__["a" /* parameter */]],

  props: {
    default: Number,
    decimals: 0
  },

  data: function data() {
    return {
      type: 'Knob'
      // _temp: 0 // used to check if value was changed externally (ie via $store)
    };
  },


  computed: {
    /**
     * Helper function for the path attribute d in the svg display.
     * @return {string} The new path attribute.
     */
    arc: function arc() {
      var rotationValue = this.internalValue * 300 + 30; // 30 -> 330. Dials start 30deg in and end 30deg before 360.
      return describeArc(X, Y, SIZE, 30, rotationValue);
    }

    // /**
    //  * Getter and setter functions for the value in the vuex $store.
    //  */
    // value: {
    //   get() {
    //     return this.$store.getters.parameters[this.id] || this.default || 0;
    //   },

    //   set(value) {
    //     this._temp = value;
    //     this.$emit('value', value); // update parent w/ value
    //     this.$store.commit('SET_PARAMETER', {
    //       id: this.id,
    //       value: value
    //     });
    //   }
    // }
  },

  // watch: {
  //   value: function(value) {
  //     if (!this._temp || value !== this._temp) { // value was changed externally ie. via $store
  //       this.$store.commit('REGISTER_PARAMETER', this.id); // in the event where the new parameterSet did not contain this param, let's register it
  //       this.internalValue = this.computeValue(value, true);
  //       console.log('%c[parameter] %s Knob set to %f', 'color: orange', this.param, value);
  //     }
  //   }
  // },

  mounted: function mounted() {
    this.internalValue = this.computeValue(this.value, true);
    this.$refs.track.setAttribute('d', describeArc(X, Y, SIZE, 30, 330)); // draw track
    // this.$refs.computed.setAttribute('d', describeArc(x, y, SIZE - 4, 30, 330));  // inner track. "actual" value, from varying inputs, etc.
  }
});

/***/ }),

/***/ "eyoQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Analyser_vue__ = __webpack_require__("sBkl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7b92c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analyser_vue__ = __webpack_require__("xp7T");
function injectStyle (ssrContext) {
  __webpack_require__("tRtq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Analyser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7b92c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analyser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fVTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debugger_vue__ = __webpack_require__("Z0Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_097b9f5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debugger_vue__ = __webpack_require__("QZ/0");
function injectStyle (ssrContext) {
  __webpack_require__("cmom")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debugger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_097b9f5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debugger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fxBu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rackHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rackWidth; });
/* unused harmony export cellHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cellWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleSize; });
var rackHeight = 240;
var rackWidth = 60;

var cellHeight = 90;
var cellWidth = 120;

/**
 * Rack unit sizes when in "Play" mode. The third item is the module height
 * when in in "Edit" mode.
 * @type {Object}
 */
var moduleSize = {
  'Analyser': [6, 1],
  'Clock': {},
  'Comb': [3, 1],
  'Compressor': [3, 1],
  'Debugger': [1, 1],
  'Delay': [4, 1],
  'Drive': [2, 1],
  'Env': [3, 1],
  'Filter': [3, 1],
  'LFO': [2, 1],
  'Mixer': [3, 1, 'tall'],
  'Node': [4, 1],
  'NoteIn': [2, 1, 'tall'],
  'Reverb': [3, 1],
  'VCA': [2, 1],
  'VCF': [3, 1],
  'VCO': [4, 1]
};

/***/ }),

/***/ "gDDd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.devices.length)?_c('div',{staticClass:"midi"},[_c('h3',[_vm._v("midi infos")]),_vm._v(" "),_c('select',{staticClass:"midi-in select",on:{"change":_vm.onSelect}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("<select input>")]),_vm._v(" "),_vm._l((_vm.devices),function(value){return _c('option',{key:value._uid,domProps:{"value":value._uid}},[_vm._v("\n      "+_vm._s(value.name)+"\n    ")])})],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gUOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.editing ? 'edit-mode': 'play-mode'},[_c('div',{ref:"grid",attrs:{"id":"modules"},on:{"click":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.clearActive($event)}}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.modules),function(module,index){return _c('module',{key:module.id,attrs:{"module":module},nativeOn:{"mousedown":function($event){_vm.setActive(module.id)},"mouseover":function($event){_vm.setFocus(module.id)},"mouseout":function($event){_vm.clearFocus()}}})}),_vm._v(" "),_c('svg',{style:(_vm.width),attrs:{"id":"connections"}},[_c('connecting'),_vm._v(" "),_vm._l((_vm.connections),function(connection){return _c('connection',{key:connection.id,attrs:{"id":connection.id,"to":connection.to,"from":connection.from},nativeOn:{"mousedown":function($event){_vm.setActive(connection.id)}}})})],2)],2),_vm._v(" "),_c('aside',{attrs:{"id":"sidebar"}},[_c('div',{staticClass:"controls pad"},[_c('h4',[_vm._v(_vm._s(_vm.editing ? 'EDIT MODE' : 'PERFORMANCE MODE'))]),_vm._v(" "),_c('button',{staticClass:"mode",on:{"click":_vm.toggleEditMode}},[_c('span',{staticClass:"play"},[_vm._v("play")]),_vm._v(" "),_c('span',{staticClass:"edit"},[_vm._v("edit")])]),_vm._v(" "),(_vm.active)?_c('p',[_c('strong',[_vm._v("Current Module")]),_c('br'),_vm._v("\n        "+_vm._s(_vm.active.type)+" (id: "+_vm._s(_vm.active.id)+")"),_c('br'),_vm._v("\n        x, y: "+_vm._s(_vm.active.x)+", "+_vm._s(_vm.active.y)),_c('br'),_vm._v("\n        col, row: "+_vm._s(_vm.active.col)+", "+_vm._s(_vm.active.row)),_c('br'),_vm._v("\n        w, h: "+_vm._s(_vm.active.w)+",  "+_vm._s(_vm.active.h)),_c('br')]):_vm._e(),_vm._v(" "),_c('midi')],1),_vm._v(" "),_c('master-out'),_vm._v(" "),_c('div',{staticClass:"power pad"},[_c('button',{class:_vm.power ? 'on' : 'off',on:{"click":_vm.togglePower}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M28,18c0,6.629-5.375,12-12,12C9.371,30,4,24.629,4,18c0-5.223,3.34-9.652,8-11.301v4.41C9.617,12.496,8,15.047,8,18 c0,4.418,3.582,8,8,8s8-3.582,8-8c0-2.953-1.621-5.504-4-6.891v-4.41C24.656,8.348,28,12.777,28,18z M16,16c1.105,0,2-0.895,2-2V4 c0-1.104-0.895-2-2-2s-2,0.896-2,2v10C14,15.105,14.895,16,16,16z"}})])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-highlight"},[_c('div',{staticClass:"inner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gkgt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gp8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hF4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__audio__ = __webpack_require__("AdJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Dropdown__ = __webpack_require__("uXcz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Knob__ = __webpack_require__("nd8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_Slider__ = __webpack_require__("l9G1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Dropdown: __WEBPACK_IMPORTED_MODULE_1__UI_Dropdown__["a" /* default */], Knob: __WEBPACK_IMPORTED_MODULE_2__UI_Knob__["a" /* default */], Slider: __WEBPACK_IMPORTED_MODULE_3__UI_Slider__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'LFO',
      freq: 2.0,
      mod: 0,
      min: 0.1,
      max: 50,
      phase: 0,
      offset: 0,
      type: 'sine',
      types: ['sine', 'square', 'sawtooth', 'triangle'],

      inlets: [{
        label: 'reset',
        desc: ''
      }, {
        label: 'mod',
        desc: 'The amount of frequency modulation'
      }],

      outlets: [{
        label: 'output',
        desc: 'Audio output'
      }]
    };
  },
  created: function created() {
    // LFO
    this.lfo = this.context.createOscillator();
    this.lfo.type = this.type;
    this.lfo.frequency.value = this.freq;

    // Modulation depth
    this.modDepth = this.context.createGain();
    this.modDepth.value = 0;
    this.modDepth.connect(this.lfo.detune);
    // this.modDepth = new Parameter2(0);
    // this.modDepth.connect(this.lfo.detune);

    // Inlets
    this.inlets[0].data = this.reset; // input is 'data'. mapped to a fn
    this.inlets[1].audio = this.modDepth;

    // Outlets
    this.outlets[0].audio = this.lfo;

    // Map k-Params
    this.$watch('freq', this.setFreq);
    this.$watch('mod', this.setDepth);
    this.$watch('type', this.setType);

    this.lfo.start();
  },


  methods: {
    reset: function reset() {},


    /**
     * k-rate control of the Oscillator frequency.
     * @param {Float} f frequency
     */
    setFreq: function setFreq(f) {
      this.lfo.frequency.value = f;
    },


    /**
     * Update the (frequency) modulation depth.
     * @param {Float} d Depth, betwen 0 and 100.
     */
    setDepth: function setDepth(d) {
      this.modDepth.gain.value = d;
      // this.modDepth.set(d);
    },


    /**
     * Update wave type
     * @param {String} t One of the pre-defined oscillator wave types
     */
    setType: function setType(t) {
      this.lfo.type = t;
    }
  }
});

/***/ }),

/***/ "hNeE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hZXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Synth_vue__ = __webpack_require__("W8xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb22c94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Synth_vue__ = __webpack_require__("gUOG");
function injectStyle (ssrContext) {
  __webpack_require__("Ap8I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Synth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb22c94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Synth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iiGN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jA6h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jSOQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jex4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown",class:_vm.active ? 'active' : '',on:{"mousedown":function($event){$event.stopPropagation();_vm.open($event)}}},_vm._l((_vm.options),function(option,index){return _c('li',{class:index == _vm.selected ? 'active' : '',on:{"mouseup":function($event){_vm.select(index)}}},[_vm._v("\n    "+_vm._s(option)+"\n   ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jhtV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"patch-manager pad",class:{
    'active':  _vm.$root.authenticated,
    'editing': _vm.editing
  }},[_c('button',{staticClass:"save button",on:{"click":_vm.save}},[_c('svg',{attrs:{"viewBox":"0 0 100 100"}},[_c('path',{attrs:{"fill":"currentColor","d":"M88.236,43.25c-0.309-14.487-12.151-26.134-26.707-26.134c-9.603,0-18.016,5.06-22.729,12.66   c-1.733-0.51-3.573-0.785-5.473-0.785c-8.27,0-15.322,5.194-18.072,12.501C7.702,43.557,2.151,50.469,2.151,58.678   c0,9.816,7.973,17.811,17.811,17.811h14.331l0.008-5.942H19.954c-6.556,0-11.867-5.329-11.867-11.87   c0-6.557,5.324-11.876,11.867-11.876v-0.003h0.082c0.74-6.68,6.407-11.875,13.282-11.875c3.138,0,6.022,1.086,8.304,2.896   c2.584-8.548,10.513-14.769,19.901-14.769c11.477,0,20.778,9.302,20.778,20.782c0,1.113-0.087,2.211-0.251,3.281   c5.249,1.224,9.159,5.947,9.159,11.564c0,6.557-5.321,11.87-11.858,11.87H65.004l-0.011,5.942h14.339   c9.84,0,17.815-7.976,17.819-17.811C97.152,52.095,93.568,46.328,88.236,43.25z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"currentColor","d":"M62.223,60.091l-5.743-5.942l-6.29-6.508c-0.293-0.295-0.788-0.286-1.065-0.009l-6.299,6.517l-5.744,5.942   l-2.283,2.362c-0.139,0.139-0.219,0.35-0.219,0.578c0,0.119,0.021,0.235,0.061,0.336c0.115,0.297,0.383,0.48,0.699,0.48h8.641   l0.013,18.368c0,0.552,0.448,1,1,1h9.335c0.552,0,1-0.448,1-1V63.848h8.64c0.31,0,0.582-0.187,0.693-0.479   c0.124-0.319,0.058-0.699-0.166-0.928L62.223,60.091z"}})])]),_vm._v(" "),_c('div',{staticClass:"dropdowns"},[_c('div',{staticClass:"patch select"},[_c('span',[_vm._v("0"+_vm._s(_vm.patchIndex))]),_vm._v(" "),_c('button',{staticClass:"math add",on:{"click":_vm.add}},[_vm._v("+")]),_vm._v(" "),_c('button',{staticClass:"math remove",on:{"click":_vm.remove}},[_vm._v("-")]),_vm._v(" "),_c('select',{ref:"patch",domProps:{"value":_vm.currentPatchKey},on:{"change":_vm.select}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("<select patch>")]),_vm._v(" "),_vm._l((_vm.patches),function(patch,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(patch.name))])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPatchName),expression:"currentPatchName"}],attrs:{"type":"text"},domProps:{"value":(_vm.currentPatchName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentPatchName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"params select"},[_c('span',[_vm._v("0"+_vm._s(_vm.paramsIndex))]),_vm._v(" "),_c('button',{staticClass:"math add",on:{"click":_vm.addParams}},[_vm._v("+")]),_vm._v(" "),_c('button',{staticClass:"math remove",on:{"click":_vm.removeParams}},[_vm._v("-")]),_vm._v(" "),_c('select',{ref:"params",domProps:{"value":_vm.currentParamsKey},on:{"change":_vm.selectParams}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("<select settings>")]),_vm._v(" "),_vm._l((_vm.parameterSets),function(params,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(params.name))])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentParamsName),expression:"currentParamsName"}],attrs:{"type":"text"},domProps:{"value":(_vm.currentParamsName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentParamsName=$event.target.value}}})])]),_vm._v(" "),_c('auth')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kEqi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_draggable__ = __webpack_require__("Swtb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dimensions__ = __webpack_require__("fxBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Analyser__ = __webpack_require__("eyoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Comb__ = __webpack_require__("WfeG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Compressor__ = __webpack_require__("nZGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Delay__ = __webpack_require__("LENT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Drive__ = __webpack_require__("ztN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Env__ = __webpack_require__("Cpl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LFO__ = __webpack_require__("Ta8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Mixer__ = __webpack_require__("XkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NoteIn__ = __webpack_require__("JB2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OSC__ = __webpack_require__("GXat");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reverb__ = __webpack_require__("D8Wr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Filter__ = __webpack_require__("XKhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VCO__ = __webpack_require__("SYz6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__VCA__ = __webpack_require__("79Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Debugger__ = __webpack_require__("fVTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Node__ = __webpack_require__("ZzyN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_draggable__["a" /* draggable */]],
  components: {
    Analyser: __WEBPACK_IMPORTED_MODULE_2__Analyser__["a" /* default */],
    Comb: __WEBPACK_IMPORTED_MODULE_3__Comb__["a" /* default */],
    Compressor: __WEBPACK_IMPORTED_MODULE_4__Compressor__["a" /* default */],
    Debugger: __WEBPACK_IMPORTED_MODULE_16__Debugger__["a" /* default */],
    Delay: __WEBPACK_IMPORTED_MODULE_5__Delay__["a" /* default */],
    Drive: __WEBPACK_IMPORTED_MODULE_6__Drive__["a" /* default */],
    Env: __WEBPACK_IMPORTED_MODULE_7__Env__["a" /* default */],
    LFO: __WEBPACK_IMPORTED_MODULE_8__LFO__["a" /* default */],
    Mixer: __WEBPACK_IMPORTED_MODULE_9__Mixer__["a" /* default */],
    Node: __WEBPACK_IMPORTED_MODULE_17__Node__["a" /* default */],
    NoteIn: __WEBPACK_IMPORTED_MODULE_10__NoteIn__["a" /* default */],
    OSC: __WEBPACK_IMPORTED_MODULE_11__OSC__["a" /* default */],
    Reverb: __WEBPACK_IMPORTED_MODULE_12__Reverb__["a" /* default */],
    VCF: __WEBPACK_IMPORTED_MODULE_13__Filter__["a" /* default */],
    VCO: __WEBPACK_IMPORTED_MODULE_14__VCO__["a" /* default */],
    VCA: __WEBPACK_IMPORTED_MODULE_15__VCA__["a" /* default */]
  },

  props: {
    module: Object
  },

  created: function created() {
    this.id = this.module.id;
    this.width = '_' + __WEBPACK_IMPORTED_MODULE_1__dimensions__["b" /* moduleSize */][this.module.type][0] + 'U';
    this.tall = __WEBPACK_IMPORTED_MODULE_1__dimensions__["b" /* moduleSize */][this.module.type][2] ? 'module--tall' : '';

    console.log('%c[component] Creating %s', 'color: blue', this.module.type);
  },
  destroyed: function destroyed() {
    console.log('Destroying %s ', this.module.type);
  }
});

/***/ }),

/***/ "l9G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__ = __webpack_require__("Xpkp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21577fd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__ = __webpack_require__("dRge");
function injectStyle (ssrContext) {
  __webpack_require__("o0PV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21577fd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lz4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Midi_vue__ = __webpack_require__("uiQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735112ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Midi_vue__ = __webpack_require__("gDDd");
function injectStyle (ssrContext) {
  __webpack_require__("1n5O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Midi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735112ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Midi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mLHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('knob',{attrs:{"param":"freq","mode":"log","min":100,"max":12000},on:{"value":function($event){_vm.freq = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"Q","min":0,"max":1,"decimals":2},on:{"value":function($event){_vm.Q = $event}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"select",on:{"mousedown":function($event){$event.stopPropagation();},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.types),function(type){return _c('option',{domProps:{"value":type}},[_vm._v(_vm._s(type))])}))],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Filter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadPatch", function() { return loadPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savePatch", function() { return savePatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addPatch", function() { return addPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removePatch", function() { return removePatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPatches", function() { return fetchPatches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "togglePower", function() { return togglePower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleEditMode", function() { return toggleEditMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActive", function() { return setActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearActive", function() { return clearActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFocus", function() { return setFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFocus", function() { return clearFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addModule", function() { return addModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeModule", function() { return removeModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeConnection", function() { return removeConnection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__("HKa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schema__ = __webpack_require__("4mEv");






// -----------------------------------------------
//  LOAD / SAVE
// -----------------------------------------------

/**
 * Load a Patch from the Store; patches that have been previously fetched and
 * cached may be loaded directly, else fallback to localStorage.
 *
 * NOTE: we cannot load modules, connections, and parameters all at once.
 *       Modules must be mounted _first_, so that the AudioNode is available
 *       to the Connections; likewise with the Modules' settings being
 *       available to the Parameters.
 *
 * @param  {[type]} commit [description]
 * @param  {[type]} state  [description]
 * @param  {String} key    The key of the patch to load
 * @return {void}
 */
var loadPatch = function loadPatch(_ref, key) {
  var commit = _ref.commit,
      state = _ref.state;

  var patch = void 0;

  key = key || state.patchKey; // load a specific patch, or whatever current key is (from localStorage)

  // if loading patch via a specific key
  if (key && state.patches[key]) {
    patch = state.patches[key];
    commit('SET_KEY', key);
    console.log('%c Loading patch: %s ', 'background:#666;color:white;font-weight:bold;', patch.name);
  } else {
    console.log('%c Loading patch from localStorage ', 'background:#666;color:white;font-weight:bold;');
    patch = {
      id: parseInt(localStorage.getItem('id')) || __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */].id,
      name: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* _NAME */]) || __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */].name,
      modules: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* _MODULES */])) || __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */].modules,
      connections: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* _CONNECTIONS */])) || __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */].connections,
      parameterSets: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__index__["e" /* _PARAMETERS */])) || __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */].parameterSets
    };
  }

  commit('LOAD_PATCH', patch); // load: id, name, modules, and parameterSets
  commit('LOAD_CONNECTIONS', []); // first, explicitly destroy all connections

  // ensure nodes (+ inlets/outlets) are in the DOM...
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
    // ...then load new connections
    console.log('%c Routing audio... ', 'background:#666;color:white;font-weight:bold;');
    commit('LOAD_CONNECTIONS', patch.connections);

    // ...lastly, load parameters
    // commit('LOAD_PARAMETERS', patch.parameters);
  });
};

/**
 * Save the current working patch into the backend database, and persist it
 * into localStorage as well.
 * @param  {[type]} commit [description]
 * @param  {[type]} state  [description]
 * @param  {Object} data   Patch and parameter names, other patch data
 * @return {void}
 */
var savePatch = function savePatch(_ref2, data) {
  var commit = _ref2.commit,
      state = _ref2.state;

  var key = state.patchKey;
  var patch = {
    id: state.id,
    name: state.name,
    modules: state.modules,
    connections: state.connections,
    parameterSets: state.parameterSets
  };

  // Update patch in Database
  __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* api */].save('patch/' + key, patch).then(function () {
    console.log('saved: ', patch.name);
  }).catch(function (err) {
    console.log(err);
  });

  // Update patch in localStorage
  commit('SAVE_PATCH', {
    key: key,
    patch: patch
  });
};

/**
 * Insert a new, blank patch into the workspace.
 * @param {[type]} commit [description]
 * @param {[type]} state  [description]
 */
var addPatch = function addPatch(_ref3) {
  var commit = _ref3.commit,
      state = _ref3.state;

  var key = Object(__WEBPACK_IMPORTED_MODULE_2__firebase__["c" /* generateKey */])();

  // Create new patch in Database
  __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* api */].create(key, __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */]);

  // Create new patch in localStorage
  commit('SAVE_PATCH', {
    key: key,
    patch: __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* DEFAULT */]
  });

  // Update App keys
  state.patchKey = key;
  state.parameterKey = 0;
};

/**
 * Remove a patch.
 * @param {[type]} commit [description]
 * @param {[type]} state  [description]
 */
var removePatch = function removePatch(_ref4, key) {
  var commit = _ref4.commit,
      state = _ref4.state;

  __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* api */].remove('patch/' + key);
  commit('REMOVE_PATCH', key);

  // Update App keys
  state.patchKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.patches)[0]; // choose first key (oldest)
  state.parameterKey = 0;
  loadPatch({ commit: commit, state: state });
};

/**
 * Fetch all of the user's patches from the backend.
 * @param  {[type]} commit [description]
 * @return {[type]}        [description]
 */
var fetchPatches = function fetchPatches(_ref5) {
  var commit = _ref5.commit;

  __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* api */].load('/patch').then(function (patches) {
    console.log('%c Patches synched from API ', 'background:#666;color:white;font-weight:bold;');
    commit('SET_PATCHES', patches);
  }).catch(function () {
    console.log('Not signed in.');
  });
};

// -----------------------------------------------
//  APP
// -----------------------------------------------

var togglePower = function togglePower(_ref6) {
  var commit = _ref6.commit;

  commit('TOGGLE_POWER');
};

var toggleEditMode = function toggleEditMode(_ref7) {
  var commit = _ref7.commit;

  commit('TOGGLE_EDIT');
};

// -----------------------------------------------
//  UI
// -----------------------------------------------

var setActive = function setActive(_ref8, id) {
  var commit = _ref8.commit;

  commit('SET_ACTIVE', id);
};

var clearActive = function clearActive(_ref9) {
  // commit('CLEAR_ACTIVE');

  var commit = _ref9.commit;
};

// TODO ----------------- move to VUE BUS ? or within App.vue only ...?
// $emit event ... only connecting.vue needs this...
var setFocus = function setFocus(_ref10, id) {
  var commit = _ref10.commit;

  commit('SET_FOCUS', id);
};

var clearFocus = function clearFocus(_ref11) {
  var commit = _ref11.commit;

  commit('CLEAR_FOCUS');
};
// ---------------------------------------


// -----------------------------------------------
//  MODULES
// -----------------------------------------------

var addModule = function addModule(_ref12, data) {
  var commit = _ref12.commit;

  commit('ADD_MODULE', data);
};

var removeModule = function removeModule(_ref13) {
  var commit = _ref13.commit,
      state = _ref13.state;

  // only delete active/focused modules
  if (state.active === state.focused) {
    var id = state.active;

    commit('REMOVE_MODULE', id);

    state.connections.forEach(function (connection) {
      if (connection.to.id === id || connection.from.id === id) {
        commit('REMOVE_CONNECTION', connection.id);
      }
    });

    // Note: KNOB / SLIDERS will remove themselves, yay!
  }
};

// -----------------------------------------------
//  CONNECTIONS
// -----------------------------------------------

// export const addConnection = ({ commit }, outlet) => {
//   commit('ADD_CONNECTION', outlet.port);
// };

var removeConnection = function removeConnection(_ref14, id) {
  var commit = _ref14.commit;

  commit('REMOVE_CONNECTION', id);
};

/***/ }),

/***/ "mVKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var defaults = {
  lanes: 3,
  direction: 'horizontal'
};

var GridList = function () {
  /**
   * A GridList manages the two-dimensional positions from a list of items,
   * within a virtual matrix.
   *
   * The GridList's main function is to convert the item positions from one
   * grid size to another, maintaining as much of their order as possible.
   *
   * The GridList's second function is to handle collisions when moving an item
   * over another.
   *
   * The positioning algorithm places items in columns. Starting from left to
   * right, going through each column top to bottom.
   *
   * The size of an item is expressed using the number of cols and rows it
   * takes up within the grid (w and h)
   *
   * The position of an item is express using the col and row position within
   * the grid (x and y)
   *
   * An item is an object of structure:
   * {
   *   w: 3, h: 1,
   *   x: 0, y: 1
   * }
   */
  function GridList(items, options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GridList);

    this._options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(defaults, options);
    this.items = items; // TODO these do not have reference to DOM nodes... only the DATA within vue...
    // this._adjustSizeOfItems();
    this.generateGrid();
  }

  /**
   * Illustates grid as text-based table, using a number identifier for each
   * item. E.g.
   *
   *  #|  0  1  2  3  4  5  6  7  8  9 10 11 12 13
   *  --------------------------------------------
   *  0| 00 02 03 04 04 06 08 08 08 12 12 13 14 16
   *  1| 01 -- 03 05 05 07 09 10 11 11 -- 13 15 --
   *
   * Warn: Does not work if items don't have a width or height specified
   * besides their position in the grid.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GridList, [{
    key: 'toString',
    value: function toString() {
      var widthOfGrid = this.grid.length;
      var output = '\n #|';
      var border = '\n --';
      var item;
      var i;
      var j;
      // var id;

      // Render the table header
      for (i = 0; i < widthOfGrid; i++) {
        output += ' ' + this._padNumber(i, ' ');
        border += '---';
      };
      output += border;

      // Render table contents row by row, as we go on the y axis
      for (i = 0; i < this._options.lanes; i++) {
        output += '\n' + this._padNumber(i, ' ') + '|';
        for (j = 0; j < widthOfGrid; j++) {
          output += ' ';
          item = this.grid[j][i];
          // id = this.items.indexOf(item);
          // id = item.id;
          output += item ? this._padNumber(item.id, '0') : '--';
        }
      };
      output += '\n';
      return output;
    }
  }, {
    key: 'generateGrid',
    value: function generateGrid() {
      /**
       * Build the grid structure from scratch, with the current item positions
       */
      var i;
      this._resetGrid();
      for (i = 0; i < this.items.length; i++) {
        this._markItemPositionToGrid(this.items[i]);
      }
    }
  }, {
    key: 'resizeGrid',
    value: function resizeGrid(lanes) {
      var currentColumn = 0;

      this._options.lanes = lanes;
      // this._adjustSizeOfItems();

      this._sortItemsByPosition();
      this._resetGrid();

      // The items will be sorted based on their index within the this.items array,
      // that is their "1d position"
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        var position = this._getItemPosition(item);

        this._updateItemPosition(item, this.findPositionForItem(item, { col: currentColumn, row: 0 }));

        // New items should never be placed to the left of previous items
        currentColumn = Math.max(currentColumn, position.col);
      }

      this._pullItemsToLeft();
    }
  }, {
    key: 'findPositionForItem',
    value: function findPositionForItem(item, start, fixedRow) {
      /**
       * This method has two options for the position we want for the item:
       * - Starting from a certain row/column number and only looking for
       *   positions to its right
       * - Accepting positions for a certain row number only (use-case: items
       *   being shifted to the left/right as a result of collisions)
       *
       * @param {Object<x:Number, y:Number, w:Number, h:Number} item
       * @param {Object<x:Number, y:Number} start Position from which to start
       *     the search.
       * @param {Number} [fixedRow] If provided, we're going to try to find a
       *     position for the new item on it. If doesn't fit there, we're going
       *     to put it on the first row.
       *
       * @returns {Number[2]} x and y.
       */

      var x, y, position;

      // Start searching for a position from the horizontal position of the
      // rightmost item from the grid
      for (x = start.col; x < this.grid.length; x++) {
        if (fixedRow !== undefined) {
          position = [x, fixedRow];

          if (this._itemFitsAtPosition(item, position)) {
            return position;
          }
        } else {
          for (y = start.row; y < this._options.lanes; y++) {
            position = [x, y];

            if (this._itemFitsAtPosition(item, position)) {
              return position;
            }
          }
        }
      }

      // If we've reached this point, we need to start a new column
      var newCol = this.grid.length;
      var newRow = 0;

      if (fixedRow !== undefined && this._itemFitsAtPosition(item, [newCol, fixedRow])) {
        newRow = fixedRow;
      }

      return [newCol, newRow];
    }
  }, {
    key: 'moveItemToPosition',
    value: function moveItemToPosition(item, newPosition) {
      var position = this._getItemPosition({
        col: newPosition[0],
        row: newPosition[1],
        w: item.w,
        h: item.h
      });

      this._updateItemPosition(item, [position.col, position.row]);
      this._resolveCollisions(item);
    }

    // resizeItem(item, size) {
    //   /**
    //    * Resize an item and resolve collisions.
    //    *
    //    * @param {Object} item A reference to an item that's part of the grid.
    //    * @param {Object} size
    //    * @param {Number} [size.w=item.w] The new width.
    //    * @param {Number} [size.h=item.h] The new height.
    //    */
    //
    //   var width = size.w || item.w;
    //   var height = size.h || item.h;
    //
    //   this._updateItemSize(item, width, height);
    //
    //   this._resolveCollisions(item);
    //
    //   this._pullItemsToLeft();
    // }

  }, {
    key: 'getChangedItems',
    value: function getChangedItems(initialItems, idAttribute) {
      /**
       * Compare the current items against a previous snapshot and return only
       * the ones that changed their attributes in the meantime. This includes both
       * position (x, y) and size (w, h)
       *
       * Since both their position and size can change, the items need an
       * additional identifier attribute to match them with their previous state
       */
      var changedItems = [];

      for (var i = 0; i < initialItems.length; i++) {
        var item = this._getItemByAttribute(idAttribute, initialItems[i][idAttribute]);

        if (item.col !== initialItems[i].col || item.row !== initialItems[i].row || item.w !== initialItems[i].w || item.h !== initialItems[i].h) {
          changedItems.push(item);
        }
      }

      return changedItems;
    }
  }, {
    key: '_sortItemsByPosition',
    value: function _sortItemsByPosition() {
      this.items.sort(function (item1, item2) {
        var position1 = this._getItemPosition(item1);
        var position2 = this._getItemPosition(item2);

        // Try to preserve columns.
        if (position1.col !== position2.col) {
          return position1.col - position2.col;
        }

        if (position1.row !== position2.row) {
          return position1.row - position2.row;
        }

        // The items are placed on the same position.
        return 0;
      }.bind(this));
    }

    // _adjustSizeOfItems() {
    //   /**
    //    * Some items can have 100% height or 100% width. Those dimensions are
    //    * expressed as 0. We need to ensure a valid width and height for each of
    //    * those items as the number of items per lane.
    //    */
    //
    //   for (var i = 0; i < this.items.length; i++) {
    //     var item = this.items[i];
    //
    //     // This can happen only the first time items are checked.
    //     // We need the property to have a value for all the items so that the
    //     // `cloneItems` method will merge the properties properly. If we only set
    //     // it to the items that need it then the following can happen:
    //     //
    //     // cloneItems([{id: 1, autoSize: true} {id: 2}],
    //     //            [{id: 2} {id: 1, autoSize: true}]);
    //     //
    //     // will result in
    //     //
    //     // [{id: 1, autoSize: true} {id: 2, autoSize: true}]
    //     if (item.autoSize === undefined) {
    //       item.autoSize = item.w === 0 || item.h === 0;
    //     }
    //
    //     if (item.autoSize) {
    //       if (this._options.direction === 'horizontal') {
    //         item.h = this._options.lanes;
    //       } else {
    //         item.w = this._options.lanes;
    //       }
    //     }
    //   }
    // }

  }, {
    key: '_resetGrid',
    value: function _resetGrid() {
      this.grid = [];
    }
  }, {
    key: '_itemFitsAtPosition',
    value: function _itemFitsAtPosition(item, newPosition) {
      /**
       * Check that an item wouldn't overlap with another one if placed at a
       * certain position within the grid
       */

      var position = this._getItemPosition(item);
      var x;
      var y;

      // No coordonate can be negative
      if (newPosition[0] < 0 || newPosition[1] < 0) {
        return false;
      }

      // Make sure the item isn't larger than the entire grid
      if (newPosition[1] + position.h > this._options.lanes) {
        return false;
      }

      // Make sure the position doesn't overlap with an already positioned
      // item.
      for (x = newPosition[0]; x < newPosition[0] + position.w; x++) {
        var col = this.grid[x];

        // Surely a column that hasn't even been created yet is available
        if (!col) {
          continue;
        }

        for (y = newPosition[1]; y < newPosition[1] + position.h; y++) {
          // Any space occupied by an item can continue to be occupied by the
          // same item.
          if (col[y] && col[y] !== item) {
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: '_updateItemPosition',
    value: function _updateItemPosition(item, position) {
      if (item.col !== null && item.row !== null) {
        this._deleteItemPositionFromGrid(item);
      }

      this._setItemPosition(item, position);

      this._markItemPositionToGrid(item);
    }

    // _updateItemSize(item, width, height) {
    //   /**
    //    * @param {Object} item A reference to a grid item.
    //    * @param {Number} width The new width.
    //    * @param {Number} height The new height.
    //    */
    //
    //   if (item.col !== null && item.row !== null) {
    //     this._deleteItemPositionFromGrid(item);
    //   }
    //
    //   item.w = width;
    //   item.h = height;
    //
    //   this._markItemPositionToGrid(item);
    // }

  }, {
    key: '_markItemPositionToGrid',
    value: function _markItemPositionToGrid(item) {
      /**
       * Mark the grid cells that are occupied by an item. This prevents items
       * from overlapping in the grid
       */

      var position = this._getItemPosition(item);
      var x;
      var y;

      // Ensure that the grid has enough columns to accomodate the current item.
      this._ensureColumns(position.col + position.w);

      for (x = position.col; x < position.col + position.w; x++) {
        for (y = position.row; y < position.row + position.h; y++) {
          this.grid[x][y] = item;
        }
      }
    }
  }, {
    key: '_deleteItemPositionFromGrid',
    value: function _deleteItemPositionFromGrid(item) {
      var position = this._getItemPosition(item);
      var x;
      var y;

      for (x = position.col; x < position.col + position.w; x++) {
        // It can happen to try to remove an item from a position not generated
        // in the grid, probably when loading a persisted grid of items. No need
        // to create a column to be able to remove something from it, though
        if (!this.grid[x]) {
          continue;
        }

        for (y = position.row; y < position.row + position.h; y++) {
          // Don't clear the cell if it's been occupied by a different widget in
          // the meantime (e.g. when an item has been moved over this one, and
          // thus by continuing to clear this item's previous position you would
          // cancel the first item's move, leaving it without any position even)
          if (this.grid[x][y] === item) {
            this.grid[x][y] = null;
          }
        }
      }
    }
  }, {
    key: '_ensureColumns',
    value: function _ensureColumns(N) {
      /**
       * Ensure that the grid has at least N columns available.
       */
      var i;
      for (i = 0; i < N; i++) {
        if (!this.grid[i]) {
          // this.grid.push(new GridCol(this._options.lanes));
          this.grid.push(new Array(this._options.lanes).fill(null));
        }
      }
    }
  }, {
    key: '_getItemsCollidingWithItem',
    value: function _getItemsCollidingWithItem(item) {
      var collidingItems = [];
      for (var i = 0; i < this.items.length; i++) {
        if (item !== this.items[i] && this._itemsAreColliding(item, this.items[i])) {
          collidingItems.push(i);
        }
      }
      return collidingItems;
    }
  }, {
    key: '_itemsAreColliding',
    value: function _itemsAreColliding(item1, item2) {
      var position1 = this._getItemPosition(item1);
      var position2 = this._getItemPosition(item2);

      return !(position2.col >= position1.col + position1.w || position2.col + position2.w <= position1.col || position2.row >= position1.row + position1.h || position2.row + position2.h <= position1.row);
    }
  }, {
    key: '_resolveCollisions',
    value: function _resolveCollisions(item) {
      if (!this._tryToResolveCollisionsLocally(item)) {
        this._pullItemsToLeft(item);
      }
      this._pullItemsToLeft();
    }
  }, {
    key: '_tryToResolveCollisionsLocally',
    value: function _tryToResolveCollisionsLocally(item) {
      var _this = this;

      /**
       * Attempt to resolve the collisions after moving a an item over one or more
       * other items within the grid, by shifting the position of the colliding
       * items around the moving one. This might result in subsequent collisions,
       * in which case we will revert all position permutations. To be able to
       * revert to the initial item positions, we create a virtual grid in the
       * process
       */
      var collidingItems = this._getItemsCollidingWithItem(item);
      if (!collidingItems.length) {
        return true;
      }
      var _gridList = new GridList([], this._options);
      var leftOfItem;
      var rightOfItem;
      // var aboveOfItem;
      // var belowOfItem;

      _gridList.items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.items).map(function (key) {
        return _this.items[key];
      });
      _gridList.generateGrid();

      for (var i = 0; i < collidingItems.length; i++) {
        var collidingItem = _gridList.items[collidingItems[i]];
        var collidingPosition = this._getItemPosition(collidingItem);

        // We use a simple algorithm for moving items around when collisions occur:
        // In this prioritized order, we try to move a colliding item around the
        // moving one:
        // 1. to its left side
        // 2. above it    [wes] no, removed
        // 3. under it    [wes] no, removed
        // 4. to its right side
        var position = this._getItemPosition(item);

        leftOfItem = [position.col - collidingPosition.w, collidingPosition.row];
        rightOfItem = [position.col + position.w, collidingPosition.row];
        // aboveOfItem = [collidingPosition.col, position.row - collidingPosition.h];
        // belowOfItem = [collidingPosition.col, position.row + position.h];

        if (_gridList._itemFitsAtPosition(collidingItem, leftOfItem)) {
          _gridList._updateItemPosition(collidingItem, leftOfItem);
          // } else if (_gridList._itemFitsAtPosition(collidingItem, aboveOfItem)) {
          //   _gridList._updateItemPosition(collidingItem, aboveOfItem);
          // } else if (_gridList._itemFitsAtPosition(collidingItem, belowOfItem)) {
          //   _gridList._updateItemPosition(collidingItem, belowOfItem);
        } else if (_gridList._itemFitsAtPosition(collidingItem, rightOfItem)) {
          _gridList._updateItemPosition(collidingItem, rightOfItem);
        } else {
          // Collisions failed, we must use the pullItemsToLeft method to arrange
          // the other items around this item with fixed position. This is our
          // plan B for when local collision resolving fails.
          return false;
        }
      }
      // If we reached this point it means we managed to resolve the collisions
      // from one single iteration, just by moving the colliding items around. So
      // we accept this scenario and marge the brached-out grid instance into the
      // original one
      // cloneItems(_gridList.items, this.items);
      this.items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_gridList.items).map(function (key) {
        return _gridList.items[key];
      });

      this.generateGrid();
      return true;
    }
  }, {
    key: '_pullItemsToLeft',
    value: function _pullItemsToLeft(fixedItem) {
      /**
       * Build the grid from scratch, by using the current item positions and
       * pulling them as much to the left as possible, removing as space between
       * them as possible.
       *
       * If a "fixed item" is provided, its position will be kept intact and the
       * rest of the items will be layed around it.
       */

      // Start a fresh grid with the fixed item already placed inside
      this._sortItemsByPosition();
      this._resetGrid();

      // Start the grid with the fixed item as the first positioned item
      if (fixedItem) {
        var fixedPosition = this._getItemPosition(fixedItem);
        this._updateItemPosition(fixedItem, [fixedPosition.col, fixedPosition.row]);
      }

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        var position = this._getItemPosition(item);

        // The fixed item keeps its exact position
        if (fixedItem && item === fixedItem) {
          continue;
        }

        var col = this._findLeftMostPositionForItem(item);
        var newPosition = this.findPositionForItem(item, { col: col, row: 0 }, position.row);

        this._updateItemPosition(item, newPosition);
      }
    }
  }, {
    key: '_findLeftMostPositionForItem',
    value: function _findLeftMostPositionForItem(item) {
      /**
       * When pulling items to the left, we need to find the leftmost position for
       * an item, with two considerations in mind:
       * - preserving its current row
       * - preserving the previous horizontal order between items
       */

      var tail = 0;
      var position = this._getItemPosition(item);

      for (var i = 0; i < this.grid.length; i++) {
        for (var j = position.row; j < position.row + position.h; j++) {
          var otherItem = this.grid[i][j];

          if (!otherItem) {
            continue;
          }

          var otherPosition = this._getItemPosition(otherItem);

          if (this.items.indexOf(otherItem) < this.items.indexOf(item)) {
            tail = otherPosition.col + otherPosition.w;
          }
        }
      }

      return tail;
    }
  }, {
    key: '_getItemByAttribute',
    value: function _getItemByAttribute(key, value) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i][key] === value) {
          return this.items[i];
        }
      }
      return null;
    }
  }, {
    key: '_padNumber',
    value: function _padNumber(nr, prefix) {
      // Currently works for 2-digit numbers (<100)
      return nr >= 10 ? nr : prefix + nr;
    }
  }, {
    key: '_getItemPosition',
    value: function _getItemPosition(item) {
      /**
       * If the direction is vertical we need to rotate the grid 90 deg to the
       * left. Thus, we simulate the fact that items are being pulled to the top.
       *
       * Since the items have widths and heights, if we apply the classic
       * counter-clockwise 90 deg rotation
       *
       *     [0 -1]
       *     [1  0]
       *
       * then the top left point of an item will become the bottom left point of
       * the rotated item. To adjust for this, we need to subtract from the y
       * position the height of the original item - the width of the rotated item.
       *
       * However, if we do this then we'll reverse some actions: resizing the
       * width of an item will stretch the item to the left instead of to the
       * right; resizing an item that doesn't fit into the grid will push the
       * items around it instead of going on a new row, etc.
       *
       * We found it better to do a vertical flip of the grid after rotating it.
       * This restores the direction of the actions and greatly simplifies the
       * transformations.
       */

      if (this._options.direction === 'horizontal') {
        return item;
      } else {
        return {
          row: item.row,
          col: item.col,
          w: item.h,
          h: item.w
        };
      }
    }
  }, {
    key: '_setItemPosition',
    value: function _setItemPosition(item, position) {
      /**
       * See _getItemPosition.
       */

      if (this._options.direction === 'horizontal') {
        item.col = position[0];
        item.row = position[1];
      } else {
        // We're supposed to subtract the rotated item's height which is actually
        // the non-rotated item's width.
        item.col = position[1];
        item.row = position[0];
      }
    }
  }]);

  return GridList;
}();

/* harmony default export */ __webpack_exports__["a"] = (GridList);
;

/***/ }),

/***/ "n/Yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT; });
var EVENT = {

  // MIDI
  MIDI_NOTEON: 'midi:noteOn',
  MIDI_NOTEOFF: 'midi:noteOff',
  MIDI_CONTROLLER: 'midi:controller',
  MIDI_PITCH: 'midi:pitchWheel',
  MIDI_POLY: 'midi:polyPressure',

  // CONNECTIONS
  CONNECTION_START: 'connection:start',

  // PARAMETERS
  PARAMETERS_LOAD: 'parameters:load',

  // DRAG
  DRAG_START: 'drag:start',
  DRAG_ACTIVE: 'drag:active',
  DRAG_END: 'drag:end',

  // SORT
  APP_SORT: 'app:sort',

  // MODULES
  MODULE_ADD: 'module:add',
  MODULE_REMOVE: 'module:remove',

  // NATIVE
  MOUSE_MOVE: 'mousemove',
  MOUSE_UP: 'mouseup',
  KEY_DOWN: 'keydown',
  KEY_UP: 'keyup',
  SCROLL: 'scroll',
  RESIZE: 'resize',
  CLICK: 'click'
  // CONTEXT_MENU: 'contextmenu'
};

/***/ }),

/***/ "nZGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compressor_vue__ = __webpack_require__("SHjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf1c60a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compressor_vue__ = __webpack_require__("OfeQ");
function injectStyle (ssrContext) {
  __webpack_require__("AnxV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compressor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf1c60a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compressor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nd8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knob_vue__ = __webpack_require__("ePeR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240129f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Knob_vue__ = __webpack_require__("u0o9");
function injectStyle (ssrContext) {
  __webpack_require__("gp8M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240129f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Knob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o0PV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oMfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dimensions__ = __webpack_require__("fxBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__("n/Yi");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      active: false,
      from: {},
      port: null,
      cursorX: false,
      cursorY: false
    };
  },


  /**
   *
   */
  created: function created() {
    var _this = this;

    this.$bus.$on('connection:start', function (port, id) {
      _this.from = _this.$store.state.modules.find(function (module) {
        return module.id === id;
      });
      _this.port = port;

      _this.cursorX = _this.x = _this.from.x + __WEBPACK_IMPORTED_MODULE_0__dimensions__["a" /* cellWidth */] + 3; // line ends at cursor, which is initially the same point
      _this.cursorY = _this.y = _this.from.y + _this.port * 20 + 27;

      document.addEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_MOVE, _this.drag);
      document.addEventListener(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* EVENT */].MOUSE_UP, _this.dragEnd);

      _this.active = true;
    });
  },


  methods: {
    /**
     * Update the connector's position.
     * @param  {Event} event The mousemove Event.
     * @return {Void}
     */
    drag: function drag(event) {
      this.cursorX = event.clientX + this.$store.state.canvasOffset;
      this.cursorY = event.clientY - 48; // the header height

      event.stopPropagation();
    },


    /**
     * Finalize the connector's position.
     * @param  {Event} event: The mousemove Event.
     * @return {Void}
     */
    dragEnd: function dragEnd(event) {
      var target = event.toElement || event.relatedTarget || event.target || false;
      var port = target.getAttribute('data-port');

      if (target && port) {
        // NOTE: port is a String, so "0" is cool here
        var focused = this.$store.state.focused; // ironically, we dont even use the target to fetch the Component

        this.to = this.$store.state.modules.find(function (module) {
          return module.id === focused;
        });

        if (this.to.id !== this.from.id && // if not circular connection
        this.isUnique() // is not a duplicated connection
        ) {
            this.$store.commit('ADD_CONNECTION', {
              to: {
                id: this.to.id,
                port: parseInt(port)
              },
              from: {
                id: this.from.id,
                port: this.port
              }
            });
          }
      }

      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.dragEnd);

      this.active = false;
      this.cursorX = false;
      this.cursorY = false;
    },


    /**
     * Checks if a connection already exists between the start and end nodes.
     */
    isUnique: function isUnique() {
      return true; // TODO
    }
  }
});

/***/ }),

/***/ "pKEi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pn+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Node',
      inlets: [{ label: 'freq' }, { label: 'gain' }, { label: 'range' }],

      outlets: [{ label: 'output-1' }, { label: 'output-2' }]
    };
  },
  created: function created() {
    // dummy outlet for test
    this.inlets[0].audio = this.context.createGain();

    this.outlets[0].audio = this.context.createGain();
    this.outlets[1].audio = this.context.createGain();
  }
});

/***/ }),

/***/ "r0no":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audio__ = __webpack_require__("AdJ8");

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['power'])),

  props: {
    audio: null // window.AudioNode
  },

  created: function created() {
    var _this = this;

    this.meter = new __WEBPACK_IMPORTED_MODULE_2__audio__["a" /* Meter */]();
    this.ticking = true;

    this.$watch('power', function (on) {
      if (on) {
        _this.loop();
      } else {
        // set buffer to 0 and update display
      }
    });
  },
  destroyed: function destroyed() {
    // clean up METER // TODO
  },
  mounted: function mounted() {
    var meterContext = this.meterContext = this.$refs.vu.getContext('2d');
    var meterGraident = this.meterGraident = meterContext.createLinearGradient(0, 0, 0, 132);

    this.audio.connect && this.audio.connect(this.meter);

    meterContext.canvas.width = 20;
    meterContext.canvas.height = 132;

    meterGraident.addColorStop(0, '#BFFF02');
    meterGraident.addColorStop(0.8, '#02FF24');
    meterGraident.addColorStop(1, '#FF0202');
  },


  methods: {
    draw: function draw() {
      var level = this.meter.volume; // * 0.8; // scale it since values go above 1 when clipping
      var meterContext = this.meterContext;

      //                     x, y, width, height
      meterContext.clearRect(0, 0, 20, 132);
      meterContext.fillStyle = this.meterGraident;
      meterContext.fillRect(0, 0, 20, 132);
      meterContext.fillStyle = 'black';
      meterContext.fillRect(0, 132 * level, 20, 132);
    },
    loop: function loop() {
      if (this.power) {
        if (this.ticking) {
          this.draw();
        }

        this.ticking = !this.ticking;
        window.requestAnimationFrame(this.loop);
        // } else {
        // this.draw();    // draw one final to clear canvas
      }
    }
  }
});

/***/ }),

/***/ "raWs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__audio__ = __webpack_require__("AdJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_1__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Filter',

      freq: 440,
      mod: 21,
      Q: 1,
      type: 'allpass',
      types: ['allpass', 'bandpass', 'highpass', 'lowpass', 'peaking'],

      inlets: [{ label: 'input',
        desc: 'The signal to filter' }, { label: 'freq',
        desc: 'The filter frequency' }, { label: 'mod' }],

      outlets: [{
        label: 'output',
        desc: 'Audio output' }]
    };
  },
  created: function created() {
    // Filter
    this.filter = this.context.createBiquadFilter();
    this.filter.type = this.types[0];
    this.filter.frequency.value = this.freq;
    this.filter.Q.value = this.Q; // this.Q_;

    // Mod
    this.mod_ = new __WEBPACK_IMPORTED_MODULE_0__audio__["d" /* Parameter */](this.mod * 500); // range: 0-500, interval of a 5th
    this.mod_.output.connect(this.filter.detune); // filter tremolo

    // Inlets
    this.inlets[0].audio = this.filter;
    this.inlets[1].data = this.setFreq;
    this.inlets[2].audio = this.mod_.input;

    // Outlets
    this.outlets[0].audio = this.filter;

    // Map k-Params
    this.$watch('freq', this.setFreq);
    this.$watch('Q', this.setQ);
    this.$watch('type', this.setType);
  },


  methods: {
    setFreq: function setFreq(f) {
      this.filter.frequency.value = f;
    },
    setQ: function setQ(q) {
      this.filter.Q.value = q;
    },
    setType: function setType(t) {
      this.filter.type = t || 'lowpass';
    }
  }
});

/***/ }),

/***/ "sBkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: null
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['power', 'editing'])),

  data: function data() {
    return {
      name: 'Analyser',
      inlets: [{ label: 'input' }]
    };
  },
  created: function created() {
    var _this = this;

    this.analyser = this.inlets[0].audio = this.context.createAnalyser();
    this.analyser.fftSize = 512; // 1024;
    this.analyser.maxDecibels = -30;
    this.analyser.minDecibels = -100;

    this._buffer = new Float32Array(this.analyser.frequencyBinCount);
    this._type = 'FFT';
    this.ticking = true;

    this.$watch('power', function (on) {
      if (on) {
        _this.loop();
      } else {
        // set buffer to 0 and update display
        _this.visualizer.clearRect(0, 0, 222, 356);
      }
    });
  },
  destroyed: function destroyed() {
    // this.analyser.disconnect();// this is done in Connection

    this._buffer = null; //  ... Float32Array destroy ...??
  },
  mounted: function mounted() {
    this.visualizer = this.$refs.visualization.getContext('2d');
  },


  methods: {
    // from Tone.js
    analyse: function analyse() {
      if (this._type === 'FFT') {
        // FFT
        this.analyser.getFloatFrequencyData(this._buffer);
      } else {
        // waveform
        this.analyser.getFloatTimeDomainData(this._buffer);
      }
    },
    render: function render() {
      var values = this._buffer;
      var length = values.length;
      var canvasWidth = this.visualizer.canvas.width;
      var canvasHeight = this.visualizer.canvas.height;
      var barWidth = canvasWidth / length;

      this.visualizer.clearRect(0, 0, canvasWidth, canvasHeight);

      for (var i = 0, x = 0; i < length; i++) {
        var val = values[i] + 140; // why 140? no idea. Came from Mozilla docs

        // val = isFinite(val) ? val : 0;

        this.visualizer.fillStyle = 'rgba(0, 222, 0, ' + val / 140 + ')';
        // this.visualizer.fillStyle = 'rgb(0, 222, 0)';
        this.visualizer.fillRect(x, canvasHeight - val, barWidth, val);

        x += barWidth + 1;
      }
    },
    loop: function loop() {
      if (this.power) {
        if (!this.editing && this.ticking) {
          this.analyse();
          this.render();
        }

        this.ticking = !this.ticking;

        window.requestAnimationFrame(this.loop); // .bind(this)
      }
    }
  }
});

/***/ }),

/***/ "sccb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__audio__ = __webpack_require__("AdJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_1__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Env',

      'A': 0.1,
      'D': 0.1,
      'S': 0.6,
      'R': 0.1,

      inlets: [{ label: 'vel',
        desc: 'Acts as a trigger for the envelope' }, { label: 'mod',
        desc: '???' }],

      outlets: [{ label: 'out' }]
    };
  },
  created: function created() {
    this.adsr = this.context.createGain();
    this.adsr.gain.value = 0;

    this.inlets[0].data = this.gate; // input is mapped to gate fn
    // this.inlets[1].data = function() {};  // mod?

    this.outlets[0].audio = this.adsr;
    Object(__WEBPACK_IMPORTED_MODULE_0__audio__["f" /* signal */])(1).connect(this.adsr);
  },
  destroyed: function destroyed() {
    // signal(1).disconnect();   // or is it:
    this.adsr.disconnect(); // ...?

    // DESTROY signal? TODO
  },


  methods: {
    gate: function gate(velocity) {
      if (velocity) {
        this.start();
      } else {
        this.stop();
      }
    },
    start: function start() {
      // "trigger" ?
      var now = this.context.currentTime;
      var adsr = this.adsr.gain;
      var currentValue = adsr.value; // for the case where the previous envelope is still active

      adsr.cancelScheduledValues(now);
      adsr.setValueAtTime(currentValue, now);

      // perhaps better:

      // setTargetAtTime(to, now, duration)
      // exponentialRampToValueAtTime
      adsr.linearRampToValueAtTime(1, now + this.A);
      adsr.linearRampToValueAtTime(this.S, now + this.A + this.D);
    },
    stop: function stop() {
      // "release"
      var now = this.context.currentTime;
      var adsr = this.adsr.gain;

      adsr.cancelScheduledValues(0);
      adsr.setValueAtTime(adsr.value, now);
      adsr.linearRampToValueAtTime(0, now + this.R);
    }
  }
});

/***/ }),

/***/ "tFqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: { ports: Array },
  // template: `
  //   <div class="inlets">
  //     <span v-for="(inlet, index) in ports"
  //       :data-label="inlet.label"
  //       :data-port="index"
  //       class="inlet">
  //     </span>
  //   </div>
  // `

  render: function render(createElement, context) {
    var ports = context.props.ports;

    return createElement('div', {
      class: { 'inlets': true }
    }, ports.map(function (port, i) {
      return createElement('span', {
        class: { 'inlet': true },
        attrs: {
          'data-label': port.label,
          'data-port': i
        }
      });
    }));
  }
});

/***/ }),

/***/ "tRtq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u0o9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"knob",on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();_vm.start($event)}}},[_c('path',{ref:"track",staticClass:"track",attrs:{"fill":"none","stroke-width":"8","d":""}}),_vm._v(" "),_c('path',{ref:"display",staticClass:"display",attrs:{"fill":"none","stroke-width":"8","d":_vm.arc}}),_vm._v(" "),_c('text',{attrs:{"x":"24","y":"28"}},[_vm._v(_vm._s(_vm.value.toFixed(_vm.decimals)))]),_vm._v(" "),_c('text',{attrs:{"x":"24","y":"54"}},[_vm._v(_vm._s(_vm.param))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u52T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VU_vue__ = __webpack_require__("r0no");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e4d370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VU_vue__ = __webpack_require__("dR88");
function injectStyle (ssrContext) {
  __webpack_require__("iiGN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VU_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e4d370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VU_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uXcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("SiEE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2f525ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("jex4");
function injectStyle (ssrContext) {
  __webpack_require__("YjpD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2f525ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uiQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__("n/Yi");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      midiIn: null,
      midi: null,
      devices: []
    };
  },
  created: function created() {
    var _this = this;

    if (navigator.requestMIDIAccess) {
      navigator.requestMIDIAccess({
        sysex: false
      }).then(function (midi) {
        _this.midi = midi;
        midi.onstatechange = _this.onStateChange;
        midi.inputs.forEach(function (port) {
          _this.addDevice(port);
        });
      }, function (error) {
        console.log('Error accessing MIDI', error);
      });
    } else {
      console.log('No access to MIDI devices: browser does not support WebMIDI API.');
    }
  },


  methods: {
    addDevice: function addDevice(port) {
      var device = {
        '_uid': port.id,
        'name': port.name,
        'state': port.state,
        'connection': port.connection
      };
      this.devices.push(device);
    },


    // update the device list when devices get connected, disconnected, opened or closed
    onStateChange: function onStateChange(e) {
      var port = e.port;
      var found = !!this.devices.find(function (d) {
        return d._uid === port.id;
      });

      console.log('state change ', found, port.connection, port.state);

      if (port.type === 'input') {
        if (port.state === 'disconnected' && found) {
          console.log('removing input device %s', port.id);
          // delete this.devices[port.id];
          // this.devices.splice(this.devices.indexOf(i), 1);
          this.devices.pop();
        } else if (port.state === 'connected' && !found) {
          console.log('adding input device %s', port.id);
          this.addDevice(port);
        }
      }
    },
    onSelect: function onSelect(event) {
      var id = event.target.value;
      var selected = this.midi.inputs.get(id); // NOTE: this is not an Array. It is Array-like, and get() is a property unique to it.

      if (this.midiIn) {
        this.midiIn.close(); // close current port
      }

      this.midiIn = selected; // bind new port...
      this.midiIn.onmidimessage = this.onMIDIMessage;
    },
    onMIDIMessage: function onMIDIMessage(event) {
      var cmd = event.data[0] >> 4;
      var channel = event.data[0] & 0xf;
      var note = event.data[1];
      var velocity = event.data[2];

      if (channel === 9) {
        return;
      }

      if (cmd === 8 || cmd === 9 && velocity === 0) {
        // with MIDI, note on with velocity zero is the same as note off
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_NOTEOFF, note);
      } else if (cmd === 9) {
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_NOTEON, note, velocity); // / 127.0);
      } else if (cmd === 11) {
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_CONTROLLER, note, velocity); // / 127.0);
      } else if (cmd === 14) {
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_PITCH, (velocity * 128.0 + note - 8192) / 8192.0);
      } else if (cmd === 10) {
        // poly aftertouch
        this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* EVENT */].MIDI_POLY, note, velocity); // / 127.0);
      } else {
        console.log(event.data[0] + ' ' + event.data[1] + ' ' + event.data[2]);
      }
    }
  }
});

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_PATCH", function() { return LOAD_PATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_PATCH", function() { return SAVE_PATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_PATCH", function() { return REMOVE_PATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PATCHES", function() { return SET_PATCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NAME", function() { return SET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_KEY", function() { return SET_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_POWER", function() { return TOGGLE_POWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_EDIT", function() { return TOGGLE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE", function() { return SET_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ACTIVE", function() { return CLEAR_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FOCUS", function() { return SET_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FOCUS", function() { return CLEAR_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MODULE", function() { return ADD_MODULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_MODULE", function() { return REMOVE_MODULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_GRID_POSITION", function() { return UPDATE_GRID_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RACK_POSITION", function() { return UPDATE_RACK_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SCROLL_OFFSET", function() { return UPDATE_SCROLL_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_CONNECTIONS", function() { return LOAD_CONNECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_CONNECTION", function() { return ADD_CONNECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_CONNECTION", function() { return REMOVE_CONNECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_PARAMETERS", function() { return ADD_PARAMETERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_PARAMETERS", function() { return REMOVE_PARAMETERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PARAMETERS_NAME", function() { return SET_PARAMETERS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PARAMETERS_KEY", function() { return SET_PARAMETERS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_PARAMETER", function() { return REGISTER_PARAMETER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_PARAMETER", function() { return REMOVE_PARAMETER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PARAMETER", function() { return SET_PARAMETER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dimensions__ = __webpack_require__("fxBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema__ = __webpack_require__("4mEv");



// -----------------------------------------------
//  PATCH
// -----------------------------------------------
// loads modules, id, and patch name
// connection, parameters are loaded below
var LOAD_PATCH = function LOAD_PATCH(state, patch) {
  if (patch) {
    state.id = patch.id;
    state.name = patch.name;
    state.modules = patch.modules;
    state.parameterSets = patch.parameterSets;
    // NOTE: parameters (knobs, sliders, etc) are created only after
    // their parent is; they then register themselves within the store.
    // Parameter values are then only fetched once the params:load event
    // is fired
  }
};

var SAVE_PATCH = function SAVE_PATCH(state, data) {
  var patch = data.patch;
  var key = data.key;

  state.patches[key] = patch;
};

var REMOVE_PATCH = function REMOVE_PATCH(state, key) {
  delete state.patches[key];
  // Vue.delete(state.patches, key);
  // state.patches.$remove(key);
  // state.patches = state.patches.filter(....
};

var SET_PATCHES = function SET_PATCHES(state, patches) {
  state.patches = Object(__WEBPACK_IMPORTED_MODULE_1__schema__["b" /* validateData */])(patches); // patches;
};

var SET_NAME = function SET_NAME(state, name) {
  state.name = name;
};

var SET_KEY = function SET_KEY(state, key) {
  state.patchKey = key;
};

// -----------------------------------------------
//  APP
// -----------------------------------------------
var TOGGLE_POWER = function TOGGLE_POWER(state) {
  state.power = !state.power;
};

var TOGGLE_EDIT = function TOGGLE_EDIT(state) {
  state.editing = !state.editing;
};

// -----------------------------------------------
//  UI
// -----------------------------------------------
// TODO ----------------- move to VUE BUS ?
var SET_ACTIVE = function SET_ACTIVE(state, id) {
  state.active = id;
};

var CLEAR_ACTIVE = function CLEAR_ACTIVE(state) {
  state.active = undefined;
};

var SET_FOCUS = function SET_FOCUS(state, id) {
  state.focused = id;
};

var CLEAR_FOCUS = function CLEAR_FOCUS(state) {
  state.focused = undefined;
};

// -----------------------------------------------
//  MODULES
// -----------------------------------------------
var ADD_MODULE = function ADD_MODULE(state, data) {
  var type = data.type;
  var pos = data.coords || [0, 0];
  var size = __WEBPACK_IMPORTED_MODULE_0__dimensions__["b" /* moduleSize */][type] || [1, 1];

  state.id++;
  state.modules.push({
    id: state.id,
    type: type,
    x: pos[0], // for dragging X position
    y: pos[1], // for dragging Y position
    col: 0, // for rack X position
    row: 0, // for rack Y position
    w: size[0], // for rack width
    h: size[1] // for rack height
  });
};

var REMOVE_MODULE = function REMOVE_MODULE(state, id) {
  state.modules = state.modules.filter(function (m) {
    return m.id !== id;
  });
};

// -----------------------------------------------
//  POSITION
// -----------------------------------------------
var UPDATE_GRID_POSITION = function UPDATE_GRID_POSITION(state, data) {
  // TODO this is getting called on delete module, and duplicating /
  // confusing coords of unrelated moduels
  var module = state.modules.find(function (module) {
    return module.id === data.id;
  });

  module.x = data.x;
  module.y = data.y;
};

var UPDATE_RACK_POSITION = function UPDATE_RACK_POSITION(state, data) {
  var module = state.modules.find(function (module) {
    return module.id === data.id;
  });

  module.col = data.col;
  module.row = data.row;
};

var UPDATE_SCROLL_OFFSET = function UPDATE_SCROLL_OFFSET(state, data) {
  state.canvasOffset = data;
};

// -----------------------------------------------
//  CONNECTIONS
// -----------------------------------------------
var LOAD_CONNECTIONS = function LOAD_CONNECTIONS(state, data) {
  state.connections = data;
};

var ADD_CONNECTION = function ADD_CONNECTION(state, data) {
  state.id++;
  state.connections.push({
    id: parseInt(state.id),
    to: data.to,
    from: data.from
  });
};

var REMOVE_CONNECTION = function REMOVE_CONNECTION(state, id) {
  state.connections = state.connections.filter(function (c) {
    return c.id !== id;
  });
};

// -----------------------------------------------
//  PARAMETERS
// -----------------------------------------------
var ADD_PARAMETERS = function ADD_PARAMETERS(state) {
  var key = state.parameterKey;
  var set = state.parameterSets[key];
  var copy = {
    name: '<empty>',
    params: set && set.parameters || {}
  };

  state.parameterSets.push(copy);
};

var REMOVE_PARAMETERS = function REMOVE_PARAMETERS(state, key) {
  // state.patches[state.patchKey].parameterSets.splice(id, 1); // let's try mutating the array directly
  state.parameterSets.splice(key, 1); // let's try mutating the array directly
};

var SET_PARAMETERS_NAME = function SET_PARAMETERS_NAME(state, name) {
  var key = state.parameterKey;

  state.parameterSets[key].name = name;
};

var SET_PARAMETERS_KEY = function SET_PARAMETERS_KEY(state, key) {
  state.parameterKey = key;
};

var REGISTER_PARAMETER = function REGISTER_PARAMETER(state, id) {
  var key = state.parameterKey;
  var set = state.parameterSets[key];

  if (set && !set.parameters[id]) {
    set.parameters[id] = 0;
    console.log(id, ' registered');
  } else {
    console.log(id, ' was already present');
  }
};

var REMOVE_PARAMETER = function REMOVE_PARAMETER(state, id) {
  state.parameterSets.forEach(function (set) {
    if (set.parameters[id]) {
      delete set.parameters[id];
    }
  });
};

var SET_PARAMETER = function SET_PARAMETER(state, data) {
  var key = state.parameterKey;
  var set = state.parameterSets[key];

  if (set.parameters) {
    set.parameters[data.id] = data.value;
  }
};

/***/ }),

/***/ "w2aM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__("n/Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_VU__ = __webpack_require__("u52T");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { meter } from '../../audio';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VU: __WEBPACK_IMPORTED_MODULE_3__UI_VU__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['power'])),

  data: function data() {
    return {
      name: 'Master Out',
      id: 0, // MasterOut is always id 0
      x: 0,
      y: 0,
      gain: 0.5,
      isMuted: false,
      inlets: [{ label: 'out-1' }, { label: 'out-2' }]
    };
  },
  created: function created() {
    var _this = this;

    this.stop();

    this.out1 = this.context.createGain();
    this.out2 = this.context.createGain();

    this.inlets[0].audio = this.out1;
    this.inlets[1].audio = this.out2;

    this.out1.connect(this.context.destination);
    this.out2.connect(this.context.destination);

    this.$watch('power', function (on) {
      on ? _this.start() : _this.stop();
    });

    this.$watch('gain', this.setGain);

    console.log('Creating MasterOut');
  },
  mounted: function mounted() {
    this.modules = document.querySelector('#modules'); // rare time we need to scrape DOM. Doesnt need to be reactive
    this.determinePosition();

    window.addEventListener(__WEBPACK_IMPORTED_MODULE_2__events__["a" /* EVENT */].RESIZE, this.determinePosition);
    this.modules.addEventListener(__WEBPACK_IMPORTED_MODULE_2__events__["a" /* EVENT */].SCROLL, this.determinePosition);
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    start: function start() {
      this.context.resume();
    },
    stop: function stop() {
      this.context.suspend();
    },
    setGain: function setGain(g) {
      this.out1.gain.linearRampToValueAtTime(g, this.context.currentTime + 0.1);
      this.out2.gain.linearRampToValueAtTime(g, this.context.currentTime + 0.1);
    },
    determinePosition: function determinePosition(e) {
      var x = this.modules.scrollLeft + // scroll offset +
      this.$el.getBoundingClientRect().left; // viewport offset
      var y = this.$el.offsetTop; // relative to parent

      this.x = x;
      this.y = y;

      this.$store.commit('UPDATE_GRID_POSITION', {
        id: 0,
        x: x,
        y: y
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setFocus', 'clearFocus']))
});

/***/ }),

/***/ "wApk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatchManager_vue__ = __webpack_require__("HB2W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85656f7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatchManager_vue__ = __webpack_require__("jhtV");
function injectStyle (ssrContext) {
  __webpack_require__("DD6E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatchManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85656f7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatchManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x10d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oscillator"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('p',[_vm._v("OSC")]),_vm._v(" "),_c('dropdown',{attrs:{"param":"type","options":_vm.types},on:{"value":function($event){_vm.type = $event}}}),_vm._v(" "),_c('slider',{attrs:{"param":"mod","min":0,"max":100},on:{"value":function($event){_vm.mod = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"freq","min":100,"max":12000,"default":440,"mode":"log"},on:{"value":function($event){_vm.freq = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"PW","min":0,"max":6.28},on:{"value":function($event){_vm.PW = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"detune","min":-500,"max":500},on:{"value":function($event){_vm.detune = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Oscillator")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xHYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UI_Knob__ = __webpack_require__("nd8g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Knob: __WEBPACK_IMPORTED_MODULE_0__UI_Knob__["a" /* default */] },
  props: {
    id: null
  },

  data: function data() {
    return {
      name: 'Comb',

      freq: 440,
      types: ['lowpass', 'hipass', 'bandpass', 'notch'],
      Q: 1,

      inlets: [{
        label: 'input'
        // audio: null
      }, {
        label: 'input'
        // audio: null
      }],

      outlets: [{
        label: 'output-1'
        // audio: null
      }, {
        label: 'output-2'
        // audio: null
      }]
    };
  },
  created: function created() {
    this.filter = this.context.createBiquadFilter();
    this.filter.type = this.types[0];
    this.filter.frequency.value = this.freq;
    this.filter.Q.value = this.Q;

    // connect input to our filter
    this.inlets[0].audio = this.filter;
    this.outlets[0].audio = this.filter;

    // this.$watch('type', this.setReverb);
    // this.$watch('freq', this.setDecay);
    // this.$watch('Q', this.setDecay);
  },


  // destroyed() {
  //   this.filter.disconnect();// this is done in Connection
  // },

  methods: {
    setFreq: function setFreq(f) {
      this.filter.frequency.value = f;
    },
    setType: function setType(t) {
      this.filter.type = this.types[t] || 'lowpass';
    }
  }
});

/***/ }),

/***/ "xc2I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xp7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analyser"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('canvas',{ref:"visualization"})]),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("Analyser")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sortable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_vendor_gridList__ = __webpack_require__("mVKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dimensions__ = __webpack_require__("fxBu");
/**
 * NOTE: "modules" (nee items) are from the App's internal data state.
 * They are synchronized with the vuex store via a getter. But to be
 * clear, we can destructively mess with this data array and not worry
 * too much as the source of truth is still safe within vuex.
 *
 * NOTE: As this is a mixin, several object properties are defined
 * elsewhere but referenced here. The two primary ones are:
 *   this.active
 *   this.modules

 */
var lanes = 3;




var sortable = {
  methods: {
    initSorting: function initSorting(handle) {
      this.handle = handle;
      this.$positionHighlight = this.handle.querySelector('.position-highlight');
      this.$positionHighlight.style.display = 'none';

      this.setupGrid();
    },
    setupGrid: function setupGrid() {
      this._widestItem = Math.max.apply(null, this.modules.map(function (item) {
        return item.w;
      }));
      this._tallestItem = Math.max.apply(null, this.modules.map(function (item) {
        return item.h;
      }));
      this.gridList = new __WEBPACK_IMPORTED_MODULE_0__assets_vendor_gridList__["a" /* default */](this.modules);
      this._applyPositionToItems();
    },
    startSorting: function startSorting() {
      // Since dragging actually alters the grid, we need to establish the number
      // of cols (+1 extra) before the drag starts
      this._maxGridCols = this.gridList.grid.length;
    },
    whileSorting: function whileSorting(el) {
      // WE need two things, here:
      //   - "item": which has row, col coords
      //   - "el": HTMLElement which we'll use to determine the module's actual position in the grid
      var item = this.active; // NOTE: active is available via App.vue in a vuex getter
      var newPosition = this._snapItemPositionToGrid(el, item);

      if (this._dragPositionChanged(newPosition)) {
        this._previousDragPosition = newPosition;
        this.gridList.generateGrid();
        this.gridList.moveItemToPosition(item, newPosition);

        // Visually update item positions and highlight shape
        this._applyPositionToItems();
        this._highlightPositionForItem(item);
      }
    },
    stopSorting: function stopSorting() {
      // this._triggerOnChange()
      this._previousDragPosition = null;
      this._applyPositionToItems();
      this._removePositionHighlight();

      console.log('%c' + this.gridList.toString(), 'font-family:monospace;font-size:10px');
    },


    // -----------------------------------------------------------------

    _getItemWidth: function _getItemWidth(item) {
      return item.w * __WEBPACK_IMPORTED_MODULE_1__dimensions__["d" /* rackWidth */];
    },
    _getItemHeight: function _getItemHeight(item) {
      return item.h * __WEBPACK_IMPORTED_MODULE_1__dimensions__["c" /* rackHeight */];
    },
    _applyPositionToItems: function _applyPositionToItems() {
      var _this = this;

      this.modules.forEach(function (item) {
        // Don't interfere with the position of the dragged items. TODO - is this the case...?
        if (_this.active !== item) {
          _this.$store.commit('UPDATE_RACK_POSITION', {
            id: item.id,
            col: item.col,
            row: item.row
          });
        }
      });

      this.handle.style.width = (this.gridList.grid.length + this._widestItem) * __WEBPACK_IMPORTED_MODULE_1__dimensions__["d" /* rackWidth */];
    },


    // -----------------------------------------------------------------


    _dragPositionChanged: function _dragPositionChanged(newPosition) {
      if (!this._previousDragPosition) {
        return true;
      }
      return newPosition[0] !== this._previousDragPosition[0] || newPosition[1] !== this._previousDragPosition[1];
    },
    _snapItemPositionToGrid: function _snapItemPositionToGrid(el, item) {
      // var position = el.getBoundingClientRect();
      var position = {
        left: el.offsetLeft,
        top: el.offsetTop
      };

      var col = Math.round(position.left / __WEBPACK_IMPORTED_MODULE_1__dimensions__["d" /* rackWidth */]);
      var row = Math.round(position.top / __WEBPACK_IMPORTED_MODULE_1__dimensions__["c" /* rackHeight */]);

      // Keep item position within the grid and don't
      // let the item create more than one extra column
      col = Math.max(col, 0);
      row = Math.max(row, 0);

      col = Math.min(col, this._maxGridCols);
      row = Math.min(row, lanes - item.h);

      return [col, row];
    },
    _highlightPositionForItem: function _highlightPositionForItem(item) {
      this.$positionHighlight.style.width = this._getItemWidth(item) + 'px';
      this.$positionHighlight.style.height = this._getItemHeight(item) + 'px';
      this.$positionHighlight.style.left = item.col * __WEBPACK_IMPORTED_MODULE_1__dimensions__["d" /* rackWidth */] + 'px';
      this.$positionHighlight.style.top = item.row * __WEBPACK_IMPORTED_MODULE_1__dimensions__["c" /* rackHeight */] + 'px';
      this.$positionHighlight.style.display = 'block';
    },
    _removePositionHighlight: function _removePositionHighlight() {
      this.$positionHighlight.style.display = 'none';
    }

    // _triggerOnChange() {
    //   if (typeof options.onChange !== 'function') {
    //     return;
    //   }
    //   options.onChange.call(
    //     this, this.gridList.getChangedItems(this._items, '$element'));
    // }

  }
};

/***/ }),

/***/ "zm4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contextmenu",class:{visible: _vm.visible},style:(_vm.position)},[_c('div',{staticClass:"add",class:{active: _vm.active === 'add'}},[_c('h3',[_vm._v("New Module:")]),_vm._v(" "),_c('ul',[_c('li',{on:{"click":function($event){_vm.newModule('Analyser')}}},[_vm._v("analyser")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Comb')}}},[_vm._v("comb")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Compressor')}}},[_vm._v("compressor")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Delay')}}},[_vm._v("delay")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Drive')}}},[_vm._v("drive")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Env')}}},[_vm._v("ENV")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('LFO')}}},[_vm._v("LFO")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Mixer')}}},[_vm._v("mixer")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('NoteIn')}}},[_vm._v("note-in")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('OSC')}}},[_vm._v("OSC")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Reverb')}}},[_vm._v("reverb")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('VCO')}}},[_vm._v("VCO")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('VCA')}}},[_vm._v("VCA")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('VCF')}}},[_vm._v("VCF")]),_vm._v(" "),_c('li',[_vm._v("---")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Node')}}},[_vm._v("• Node")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.newModule('Debugger')}}},[_vm._v("• debugger")])])]),_vm._v(" "),_c('div',{staticClass:"file",class:{active: _vm.active === 'file'}},[_c('h3',[_vm._v("File:")]),_vm._v(" "),_c('ul',[_c('li',{on:{"click":function($event){_vm.save()}}},[_vm._v("Save")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.addPatch()}}},[_vm._v("New Patch")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.addParams()}}},[_vm._v("New Parameter Set")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.removePatch()}}},[_vm._v("Remove patch")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.removeParams()}}},[_vm._v("Remove parameter Set")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ztN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drive_vue__ = __webpack_require__("/p7q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59dfbcef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drive_vue__ = __webpack_require__("c9bl");
function injectStyle (ssrContext) {
  __webpack_require__("ZbSR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59dfbcef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zwCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lfo"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-interface"},[_c('slider',{attrs:{"param":"mod","min":0,"max":50},on:{"value":function($event){_vm.mod = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"freq","mode":"log","min":_vm.min,"max":_vm.max,"decimals":1},on:{"value":function($event){_vm.freq = $event}}}),_vm._v(" "),_c('knob',{attrs:{"param":"offset","min":-1,"max":1,"decimals":1},on:{"value":function($event){_vm.offset = $event}}}),_vm._v(" "),_c('dropdown',{attrs:{"param":"type","options":_vm.types},on:{"value":function($event){_vm.type = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"module-connections"},[_c('inlets',{attrs:{"ports":_vm.inlets}}),_vm._v(" "),_c('outlets',{attrs:{"ports":_vm.outlets}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-details"},[_c('h3',[_vm._v("LFO")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.370013b2d09ece362a04.js